export const laNhaDulux = [
  '09BB 07/008',
  '17GY 27/098',
  '18GY 38/328',
  '30GG 52/011',
  '30YY 58/178',
  '33YY 69/519',
  '38YR 17/442',
  '45YY 82/098',
  '50BG 20/230',
  '50BG 61/133',
  '50GG 23/085',
  '50YR 32/460',
  '53YY 89/081',
  '70YY 18/152',
  '74YR 71/141',
  '76YR 27/558',
  '83YY 89/055',
  '89BG 09/087',
  '90GY 16/354',
  '91YY 31/059',
];

export const dulux = [
  {
    main: '#E4043F',
    image: {
      src: '/content/dam/akzonobel-common/colorWall/RCC_4/Red.jpg',
    },
    colors: [
      {
        color: {
          id: '232251',
          hex: '#853643',
          ccid: '3001081',
          href: '/vi/mau-sac-bang-mau/wine-sensation-80rr-10-306-3001081',
          name: 'Wine Sensation 80RR 10/306',
          title: 'Wine Sensation 80RR 10/306',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001081',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '232538',
          hex: '#722F2E',
          ccid: '2753296',
          href: '/vi/mau-sac-bang-mau/intense-maroon-05yr-08-272-2753296',
          name: 'Intense Maroon 05YR 08/272',
          title: 'Intense Maroon 05YR 08/272',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753296',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '232549',
          hex: '#862A2E',
          ccid: '2753283',
          href: '/vi/mau-sac-bang-mau/crimson-sunbird-02yr-09-373-2753283',
          name: 'Crimson Sunbird 02YR 09/373',
          title: 'Crimson Sunbird 02YR 09/373',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753283',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '265637',
          hex: '#984356',
          ccid: '3001052',
          href: '/vi/mau-sac-bang-mau/radical-raspberry-70rr-13-380-3001052',
          name: 'Radical Raspberry 70RR 13/380',
          title: 'Radical Raspberry 70RR 13/380',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001052',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '76636',
          hex: '#99282C',
          ccid: '3000840',
          href: '/vi/mau-sac-bang-mau/rapture-07yr-10-489-3000840',
          name: 'Rapture 07YR 10/489',
          title: 'Rapture 07YR 10/489',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000840',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '232429',
          hex: '#A32E39',
          ccid: '2753651',
          href: '/vi/mau-sac-bang-mau/chinese-sensation-99rr-12-469-2753651',
          name: 'Chinese Sensation 99RR 12/469',
          title: 'Chinese Sensation 99RR 12/469',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753651',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '52440',
          hex: '#C16D7E',
          ccid: '3001054',
          href: '/vi/mau-sac-bang-mau/arbor-rose-70rr-25-338-3001054',
          name: 'Arbor Rose 70RR 25/338',
          title: 'Arbor Rose 70RR 25/338',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001054',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '232406',
          hex: '#C23F4B',
          ccid: '3000828',
          href: '/vi/mau-sac-bang-mau/hot-hibiscus-00yr-18-531-3000828',
          name: 'Hot Hibiscus 00YR 18/531',
          title: 'Hot Hibiscus 00YR 18/531',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000828',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '232482',
          hex: '#BE5B59',
          ccid: '3000841',
          href: '/vi/mau-sac-bang-mau/marvelous-coral-07yr-21-415-3000841',
          name: 'Marvelous Coral 07YR 21/415',
          title: 'Marvelous Coral 07YR 21/415',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000841',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '100794',
          hex: '#E0899C',
          ccid: '3001032',
          href: '/vi/mau-sac-bang-mau/destiny-63rr-39-350-3001032',
          name: 'Destiny 63RR 39/350',
          title: 'Destiny 63RR 39/350',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001032',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '48520',
          hex: '#DB7680',
          ccid: '3001113',
          href: '/vi/mau-sac-bang-mau/cheery-cherry-90rr-31-403-3001113',
          name: 'Cheery Cherry 90RR 31/403',
          title: 'Cheery Cherry 90RR 31/403',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001113',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '100681',
          hex: '#DE8E89',
          ccid: '3000870',
          href: '/vi/mau-sac-bang-mau/coral-beach-10yr-38-318-3000870',
          name: 'Coral Beach 10YR 38/318',
          title: 'Coral Beach 10YR 38/318',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000870',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '232200',
          hex: '#ECB8BE',
          ccid: '2753554',
          href: '/vi/mau-sac-bang-mau/fantastic-rose-71rr-58-199-2753554',
          name: 'Fantastic Rose 71RR 58/199',
          title: 'Fantastic Rose 71RR 58/199',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753554',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '232315',
          hex: '#F4A6A8',
          ccid: '3001121',
          href: '/vi/mau-sac-bang-mau/pink-revelation-91rr-51-304-3001121',
          name: 'Pink Revelation 91RR 51/304',
          title: 'Pink Revelation 91RR 51/304',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001121',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '48284',
          hex: '#EEA197',
          ccid: '3000906',
          href: '/vi/mau-sac-bang-mau/bay-coral-22yr-50-316-3000906',
          name: 'Bay Coral 22YR 50/316',
          title: 'Bay Coral 22YR 50/316',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000906',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '232097',
          hex: '#E6CED0',
          ccid: '3001037',
          href: '/vi/mau-sac-bang-mau/cerise-feel-66rr-67-091-3001037',
          name: 'Cerise Feel 66RR 67/091',
          title: 'Cerise Feel 66RR 67/091',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001037',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '232293',
          hex: '#F9CECD',
          ccid: '3001124',
          href: '/vi/mau-sac-bang-mau/dollhouse-pink-93rr-70-157-3001124',
          name: 'Dollhouse Pink 93RR 70/157',
          title: 'Dollhouse Pink 93RR 70/157',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001124',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '232604',
          hex: '#F6D6CF',
          ccid: '3000905',
          href: '/vi/mau-sac-bang-mau/beauty-behaviour-21yr-73-125-3000905',
          name: 'Beauty Behaviour 21YR 73/125',
          title: 'Beauty Behaviour 21YR 73/125',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000905',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '232124',
          hex: '#EFDFDF',
          ccid: '2753556',
          href: '/vi/mau-sac-bang-mau/rose-feeling-72rr-78-058-2753556',
          name: 'Rose Feeling 72RR 78/058',
          title: 'Rose Feeling 72RR 78/058',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753556',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '232566',
          hex: '#F3E7E4',
          ccid: '3000895',
          href: '/vi/mau-sac-bang-mau/japanese-sensation-18yr-83-042-3000895',
          name: 'Japanese Sensation 18YR 83/042',
          title: 'Japanese Sensation 18YR 83/042',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000895',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '232568',
          hex: '#F7E7E3',
          ccid: '3000956',
          href: '/vi/mau-sac-bang-mau/neutral-blush-31yr-84-056-3000956',
          name: 'Neutral Blush 31YR 84/056',
          title: 'Neutral Blush 31YR 84/056',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000956',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '53070',
          hex: '#EBE5E5',
          ccid: '3000944',
          href: '/vi/mau-sac-bang-mau/gentle-spirit-30rr-83-020-3000944',
          name: 'Gentle Spirit 30RR 83/020',
          title: 'Gentle Spirit 30RR 83/020',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000944',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '52450',
          hex: '#EEE7E5',
          ccid: '3001115',
          href: '/vi/mau-sac-bang-mau/discreet-charm-90rr-83-021-3001115',
          name: 'Discreet Charm 90RR 83/021',
          title: 'Discreet Charm 90RR 83/021',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001115',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '232559',
          hex: '#EDE4E2',
          ccid: '3000888',
          href: '/vi/mau-sac-bang-mau/peach-whitening-13yr-80-033-3000888',
          name: 'Peach Whitening 13YR 80/033',
          title: 'Peach Whitening 13YR 80/033',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000888',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '236059',
          hex: '#EBEAE8',
          ccid: '2753585',
          href: '/vi/mau-sac-bang-mau/smokey-hint-81yr-85-004-2753585',
          name: 'Smokey Hint 81YR 85/004',
          title: 'Smokey Hint 81YR 85/004',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753585',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '232945',
          hex: '#EAE8E5',
          ccid: '2753295',
          href: '/vi/mau-sac-bang-mau/sheer-sensation-04yr-82-010-2753295',
          name: 'Sheer Sensation 04YR 82/010',
          title: 'Sheer Sensation 04YR 82/010',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753295',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '49597',
          hex: '#ECE9E7',
          ccid: '3001003',
          href: '/vi/mau-sac-bang-mau/siberian-50rr-83-006-3001003',
          name: 'Siberian 50RR 83/006',
          title: 'Siberian 50RR 83/006',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001003',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '232555',
          hex: '#DBD7D5',
          ccid: '3000842',
          href: '/vi/mau-sac-bang-mau/spacious-feeling-08yr-70-012-3000842',
          name: 'Spacious Feeling 08YR 70/012',
          title: 'Spacious Feeling 08YR 70/012',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000842',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '53100',
          hex: '#E6DAD6',
          ccid: '3000949',
          href: '/vi/mau-sac-bang-mau/easy-feeling-30yr-74-045-3000949',
          name: 'Easy Feeling 30YR 74/045',
          title: 'Easy Feeling 30YR 74/045',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000949',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '53107',
          hex: '#DBCCC6',
          ccid: '3001007',
          href: '/vi/mau-sac-bang-mau/simply-taupe-50yr-65-056-3001007',
          name: 'Simply Taupe 50YR 65/056',
          title: 'Simply Taupe 50YR 65/056',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001007',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '53079',
          hex: '#D6CCCA',
          ccid: '3001056',
          href: '/vi/mau-sac-bang-mau/executive-70rr-64-034-3001056',
          name: 'Executive 70RR 64/034',
          title: 'Executive 70RR 64/034',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001056',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '48991',
          hex: '#D8CFCD',
          ccid: '3001114',
          href: '/vi/mau-sac-bang-mau/white-lilac-90rr-64-036-3001114',
          name: 'White Lilac 90RR 64/036',
          title: 'White Lilac 90RR 64/036',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001114',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '232570',
          hex: '#E3CFCB',
          ccid: '3000904',
          href: '/vi/mau-sac-bang-mau/custard-bakery-21yr-67-074-3000904',
          name: 'Custard Bakery 21YR 67/074',
          title: 'Custard Bakery 21YR 67/074',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000904',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '237986',
          hex: '#CDC2C4',
          ccid: '2753449',
          href: '/vi/mau-sac-bang-mau/harmony-touch-40rr-57-045-2753449',
          name: 'Harmony Touch 40RR 57/045',
          title: 'Harmony Touch 40RR 57/045',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753449',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '100809',
          hex: '#C9BFBD',
          ccid: '3000871',
          href: '/vi/mau-sac-bang-mau/pelican-bluff-10yr-55-037-3000871',
          name: 'Pelican Bluff 10YR 55/037',
          title: 'Pelican Bluff 10YR 55/037',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000871',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '53102',
          hex: '#CBB3AD',
          ccid: '3000948',
          href: '/vi/mau-sac-bang-mau/wood-carving-30yr-49-097-3000948',
          name: 'Wood Carving 30YR 49/097',
          title: 'Wood Carving 30YR 49/097',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000948',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '100801',
          hex: '#B6A5A6',
          ccid: '3001055',
          href: '/vi/mau-sac-bang-mau/impressionist-taupe-70rr-41-065-3001055',
          name: 'Impressionist Taupe 70RR 41/065',
          title: 'Impressionist Taupe 70RR 41/065',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001055',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '100811',
          hex: '#9B8987',
          ccid: '3000869',
          href: '/vi/mau-sac-bang-mau/pictured-rocks-10yr-28-072-3000869',
          name: 'Pictured Rocks 10YR 28/072',
          title: 'Pictured Rocks 10YR 28/072',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000869',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '53103',
          hex: '#B18B83',
          ccid: '3000947',
          href: '/vi/mau-sac-bang-mau/cafe-mystique-30yr-31-154-3000947',
          name: 'Cafe Mystique 30YR 31/154',
          title: 'Cafe Mystique 30YR 31/154',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000947',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '100802',
          hex: '#977F82',
          ccid: '3001053',
          href: '/vi/mau-sac-bang-mau/sweet-shawna-70rr-24-096-3001053',
          name: 'Sweet Shawna 70RR 24/096',
          title: 'Sweet Shawna 70RR 24/096',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001053',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '232275',
          hex: '#85686A',
          ccid: '3001087',
          href: '/vi/mau-sac-bang-mau/chocolate-groove-82rr-18-114-3001087',
          name: 'Chocolate Groove 82RR 18/114',
          title: 'Chocolate Groove 82RR 18/114',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001087',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '49618',
          hex: '#88625A',
          ccid: '3000946',
          href: '/vi/mau-sac-bang-mau/rosemont-hall-30yr-16-162-3000946',
          name: 'Rosemont Hall 30YR 16/162',
          title: 'Rosemont Hall 30YR 16/162',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000946',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '53083',
          hex: '#6B4A50',
          ccid: '3001051',
          href: '/vi/mau-sac-bang-mau/christopher-s-cuddle-70rr-10-140-3001051',
          name: "Christopher's Cuddle 70RR 10/140",
          title: "Christopher's Cuddle 70RR 10/140",
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001051',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '232294',
          hex: '#6B5253',
          ccid: '3001090',
          href: '/vi/mau-sac-bang-mau/brownie-breakfast-87rr-12-095-3001090',
          name: 'Brownie Breakfast 87RR 12/095',
          title: 'Brownie Breakfast 87RR 12/095',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001090',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '100694',
          hex: '#79493F',
          ccid: '3000945',
          href: '/vi/mau-sac-bang-mau/coach-lamp-copper-30yr-11-219-3000945',
          name: 'Coach Lamp Copper 30YR 11/219',
          title: 'Coach Lamp Copper 30YR 11/219',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000945',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '237967',
          hex: '#492D35',
          ccid: '3001455',
          href: '/vi/mau-sac-bang-mau/juicy-blackcurrant-52rr-06-105-3001455',
          name: 'Juicy Blackcurrant 52RR 06/105',
          title: 'Juicy Blackcurrant 52RR 06/105',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001455',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '265825',
          hex: '#482E32',
          ccid: '3001088',
          href: '/vi/mau-sac-bang-mau/scottsdale-brown-84rr-05-082-3001088',
          name: 'Scottsdale Brown 84RR 05/082',
          title: 'Scottsdale Brown 84RR 05/082',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001088',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '52195',
          hex: '#5A3732',
          ccid: '3000887',
          href: '/vi/mau-sac-bang-mau/babbitt-brown-13yr-07-157-3000887',
          name: 'Babbitt Brown 13YR 07/157',
          title: 'Babbitt Brown 13YR 07/157',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000887',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
    ],
    hueName: 'Red',
  },
  {
    main: '#F28E16',
    image: {
      src: '/content/dam/akzonobel-common/colorWall/RCC_4/Orange.jpg',
    },
    colors: [
      {
        color: {
          id: '232936',
          hex: '#AE5138',
          ccid: '3000961',
          href: '/vi/mau-sac-bang-mau/burnt-furnace-38yr-17-442-3000961',
          name: 'Burnt Furnace 38YR 17/442',
          title: 'Burnt Furnace 38YR 17/442',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000961',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '233489',
          hex: '#CD6F27',
          ccid: '3001074',
          href: '/vi/mau-sac-bang-mau/lilly-pollen-76yr-27-558-3001074',
          name: 'Lilly Pollen 76YR 27/558',
          title: 'Lilly Pollen 76YR 27/558',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001074',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '101028',
          hex: '#C88626',
          ccid: '3000872',
          href: '/vi/mau-sac-bang-mau/copperleaf-10yy-30-560-3000872',
          name: 'Copperleaf 10YY 30/560',
          title: 'Copperleaf 10YY 30/560',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000872',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '232832',
          hex: '#D35338',
          ccid: '3000958',
          href: '/vi/mau-sac-bang-mau/flame-grilled-34yr-23-583-3000958',
          name: 'Flame Grilled 34YR 23/583',
          title: 'Flame Grilled 34YR 23/583',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000958',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '52566',
          hex: '#DD883A',
          ccid: '3001116',
          href: '/vi/mau-sac-bang-mau/harvest-glory-90yr-34-561-3001116',
          name: 'Harvest Glory 90YR 34/561',
          title: 'Harvest Glory 90YR 34/561',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001116',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '52580',
          hex: '#E39931',
          ccid: '3000873',
          href: '/vi/mau-sac-bang-mau/winter-squash-10yy-40-608-3000873',
          name: 'Winter Squash 10YY 40/608',
          title: 'Winter Squash 10YY 40/608',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000873',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '48544',
          hex: '#DD7B59',
          ccid: '3001006',
          href: '/vi/mau-sac-bang-mau/cinnabar-50yr-32-460-3001006',
          name: 'Cinnabar 50YR 32/460',
          title: 'Cinnabar 50YR 32/460',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001006',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '101018',
          hex: '#E6A96F',
          ccid: '3000831',
          href: '/vi/mau-sac-bang-mau/country-curry-00yy-49-387-3000831',
          name: 'Country Curry 00YY 49/387',
          title: 'Country Curry 00YY 49/387',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000831',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '233798',
          hex: '#FEA93A',
          ccid: '3000838',
          href: '/vi/mau-sac-bang-mau/gas-flame-05yy-52-658-3000838',
          name: 'Gas Flame 05YY 52/658',
          title: 'Gas Flame 05YY 52/658',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000838',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '233060',
          hex: '#F4A481',
          ccid: '3001020',
          href: '/vi/mau-sac-bang-mau/peachy-punch-58yr-49-379-3001020',
          name: 'Peachy Punch 58YR 49/379',
          title: 'Peachy Punch 58YR 49/379',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001020',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '233779',
          hex: '#EEBF8B',
          ccid: '3000843',
          href: '/vi/mau-sac-bang-mau/caramel-cookie-09yy-59-325-3000843',
          name: 'Caramel Cookie 09YY 59/325',
          title: 'Caramel Cookie 09YY 59/325',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000843',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '52201',
          hex: '#FDBA61',
          ccid: '3000886',
          href: '/vi/mau-sac-bang-mau/tropical-mango-12yy-61-523-3000886',
          name: 'Tropical Mango 12YY 61/523',
          title: 'Tropical Mango 12YY 61/523',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000886',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '233044',
          hex: '#F3C0A9',
          ccid: '3001029',
          href: '/vi/mau-sac-bang-mau/sensational-salmon-61yr-61-229-3001029',
          name: 'Sensational Salmon 61YR 61/229',
          title: 'Sensational Salmon 61YR 61/229',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001029',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '233775',
          hex: '#F6CEA2',
          ccid: '3000881',
          href: '/vi/mau-sac-bang-mau/clever-clay-11yy-68-269-3000881',
          name: 'Clever Clay 11YY 68/269',
          title: 'Clever Clay 11YY 68/269',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000881',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '233932',
          hex: '#FDD29B',
          ccid: '3000896',
          href: '/vi/mau-sac-bang-mau/northern-sunrise-19yy-71-323-3000896',
          name: 'Northern Sunrise 19YY 71/323',
          title: 'Northern Sunrise 19YY 71/323',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000896',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '233243',
          hex: '#F2D4C2',
          ccid: '3001072',
          href: '/vi/mau-sac-bang-mau/pinky-peach-74yr-71-141-3001072',
          name: 'Pinky Peach 74YR 71/141',
          title: 'Pinky Peach 74YR 71/141',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001072',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '233815',
          hex: '#F6E0C9',
          ccid: '3000882',
          href: '/vi/mau-sac-bang-mau/caramel-hint-11yy-78-136-3000882',
          name: 'Caramel Hint 11YY 78/136',
          title: 'Caramel Hint 11YY 78/136',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000882',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '233965',
          hex: '#FEE1BC',
          ccid: '2753384',
          href: '/vi/mau-sac-bang-mau/saffron-dilution-22yy-80-211-2753384',
          name: 'Saffron Dilution 22YY 80/211',
          title: 'Saffron Dilution 22YY 80/211',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753384',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '533',
          hex: '#EFDCD2',
          ccid: '3001039',
          href: '/vi/mau-sac-bang-mau/fluffy-towels-67yr-77-081-3001039',
          name: 'Fluffy Towels 67YR 77/081',
          title: 'Fluffy Towels 67YR 77/081',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001039',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '233711',
          hex: '#F4E8DA',
          ccid: '2753341',
          href: '/vi/mau-sac-bang-mau/lush-morning-14yy-83-075-2753341',
          name: 'Lush Morning 14YY 83/075',
          title: 'Lush Morning 14YY 83/075',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753341',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '52589',
          hex: '#F5E6D1',
          ccid: '3000908',
          href: '/vi/mau-sac-bang-mau/french-cream-25yy-83-103-3000908',
          name: 'French Cream 25YY 83/103',
          title: 'French Cream 25YY 83/103',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000908',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '233294',
          hex: '#F3E7DE',
          ccid: '2753592',
          href: '/vi/mau-sac-bang-mau/chic-breeze-82yr-83-056-2753592',
          name: 'Chic Breeze 82YR 83/056',
          title: 'Chic Breeze 82YR 83/056',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753592',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '53124',
          hex: '#EEE7E1',
          ccid: '3001084',
          href: '/vi/mau-sac-bang-mau/cuddle-80yr-83-026-3001084',
          name: 'Cuddle 80YR 83/026',
          title: 'Cuddle 80YR 83/026',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001084',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '263835',
          hex: '#EFE5DC',
          ccid: '3000834',
          href: '/vi/mau-sac-bang-mau/enlightened-peach-00yy-83-046-3000834',
          name: 'Enlightened Peach 00YY 83/046',
          title: 'Enlightened Peach 00YY 83/046',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000834',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '100999',
          hex: '#EDE8E3',
          ccid: '3001022',
          href: '/vi/mau-sac-bang-mau/secret-affair-60yr-83-017-3001022',
          name: 'Secret Affair 60YR 83/017',
          title: 'Secret Affair 60YR 83/017',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001022',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '233911',
          hex: '#F2ECE5',
          ccid: '2753282',
          href: '/vi/mau-sac-bang-mau/white-wallwash-01yy-86-034-2753282',
          name: 'White Wallwash 01YY 86/034',
          title: 'White Wallwash 01YY 86/034',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753282',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '615',
          hex: '#F5EEE5',
          ccid: '3000889',
          href: '/vi/mau-sac-bang-mau/marshmallow-touch-14yy-88-041-3000889',
          name: 'Marshmallow Touch 14YY 88/041',
          title: 'Marshmallow Touch 14YY 88/041',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000889',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '53106',
          hex: '#E5D9D4',
          ccid: '3001008',
          href: '/vi/mau-sac-bang-mau/angel-cloud-50yr-74-043-3001008',
          name: 'Angel Cloud 50YR 74/043',
          title: 'Angel Cloud 50YR 74/043',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001008',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '53135',
          hex: '#E3DCD4',
          ccid: '3000877',
          href: '/vi/mau-sac-bang-mau/autumnal-equinox-10yy-73-042-3000877',
          name: 'Autumnal Equinox 10YY 73/042',
          title: 'Autumnal Equinox 10YY 73/042',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000877',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '233752',
          hex: '#E6D9CC',
          ccid: '2753312',
          href: '/vi/mau-sac-bang-mau/ivory-flash-08yy-72-077-2753312',
          name: 'Ivory Flash 08YY 72/077',
          title: 'Ivory Flash 08YY 72/077',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753312',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '233231',
          hex: '#E1D2CA',
          ccid: '3001071',
          href: '/vi/mau-sac-bang-mau/sand-sensation-74yr-68-064-3001071',
          name: 'Sand Sensation 74YR 68/064',
          title: 'Sand Sensation 74YR 68/064',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001071',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '49675',
          hex: '#D9CEC4',
          ccid: '3000833',
          href: '/vi/mau-sac-bang-mau/renoir-bisque-00yy-65-060-3000833',
          name: 'Renoir Bisque 00YY 65/060',
          title: 'Renoir Bisque 00YY 65/060',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000833',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '49708',
          hex: '#E3D1BF',
          ccid: '3000876',
          href: '/vi/mau-sac-bang-mau/ivory-beige-10yy-68-110-3000876',
          name: 'Ivory Beige 10YY 68/110',
          title: 'Ivory Beige 10YY 68/110',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000876',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '72932',
          hex: '#D6C2B7',
          ccid: '3001083',
          href: '/vi/mau-sac-bang-mau/mochaccino-80yr-59-089-3001083',
          name: 'Mochaccino 80YR 59/089',
          title: 'Mochaccino 80YR 59/089',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001083',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '49677',
          hex: '#C5B5A7',
          ccid: '3000832',
          href: '/vi/mau-sac-bang-mau/indian-painting-00yy-50-091-3000832',
          name: 'Indian Painting 00YY 50/091',
          title: 'Indian Painting 00YY 50/091',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000832',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '49710',
          hex: '#D7BEA3',
          ccid: '3000875',
          href: '/vi/mau-sac-bang-mau/dapper-tan-10yy-55-163-3000875',
          name: 'Dapper Tan 10YY 55/163',
          title: 'Dapper Tan 10YY 55/163',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000875',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '233042',
          hex: '#B48D7C',
          ccid: '3001019',
          href: '/vi/mau-sac-bang-mau/authentic-leather-57yr-32-176-3001019',
          name: 'Authentic Leather 57YR 32/176',
          title: 'Authentic Leather 57YR 32/176',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001019',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '233368',
          hex: '#B59F91',
          ccid: '3001086',
          href: '/vi/mau-sac-bang-mau/glowing-brown-81yr-38-111-3001086',
          name: 'Glowing Brown 81YR 38/111',
          title: 'Glowing Brown 81YR 38/111',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001086',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '52568',
          hex: '#C9A887',
          ccid: '3000874',
          href: '/vi/mau-sac-bang-mau/naturally-calm-10yy-44-215-3000874',
          name: 'Naturally Calm 10YY 44/215',
          title: 'Naturally Calm 10YY 44/215',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000874',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '53110',
          hex: '#976856',
          ccid: '3001005',
          href: '/vi/mau-sac-bang-mau/soft-copper-50yr-18-223-3001005',
          name: 'Soft Copper 50YR 18/223',
          title: 'Soft Copper 50YR 18/223',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001005',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '265789',
          hex: '#8C7567',
          ccid: '3001082',
          href: '/vi/mau-sac-bang-mau/ancient-pottery-80yr-21-118-3001082',
          name: 'Ancient Pottery 80YR 21/118',
          title: 'Ancient Pottery 80YR 21/118',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001082',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '49719',
          hex: '#A38061',
          ccid: '3000830',
          href: '/vi/mau-sac-bang-mau/creme-brulee-00yy-26-220-3000830',
          name: 'Creme Brulee 00YY 26/220',
          title: 'Creme Brulee 00YY 26/220',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000830',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '233026',
          hex: '#864833',
          ccid: '3000975',
          href: '/vi/mau-sac-bang-mau/mud-slide-46yr-12-287-3000975',
          name: 'Mud Slide 46YR 12/287',
          title: 'Mud Slide 46YR 12/287',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000975',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '259348',
          hex: '#765B4D',
          ccid: '3001058',
          href: '/vi/mau-sac-bang-mau/cottage-chocolate-70yr-13-140-3001058',
          name: 'Cottage Chocolate 70YR 13/140',
          title: 'Cottage Chocolate 70YR 13/140',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001058',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '49706',
          hex: '#70563E',
          ccid: '3000829',
          href: '/vi/mau-sac-bang-mau/brown-study-00yy-12-173-3000829',
          name: 'Brown Study 00YY 12/173',
          title: 'Brown Study 00YY 12/173',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000829',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '49610',
          hex: '#6A4A3E',
          ccid: '3001004',
          href: '/vi/mau-sac-bang-mau/tobacco-brown-50yr-10-151-3001004',
          name: 'Tobacco Brown 50YR 10/151',
          title: 'Tobacco Brown 50YR 10/151',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001004',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '74325',
          hex: '#4E3D34',
          ccid: '3001057',
          href: '/vi/mau-sac-bang-mau/deep-brown-70yr-07-093-3001057',
          name: 'Deep Brown 70YR 07/093',
          title: 'Deep Brown 70YR 07/093',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001057',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '233530',
          hex: '#5A4A3D',
          ccid: '3001122',
          href: '/vi/mau-sac-bang-mau/hilarious-henna-91yr-10-089-3001122',
          name: 'Hilarious Henna 91YR 10/089',
          title: 'Hilarious Henna 91YR 10/089',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001122',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
    ],
    hueName: 'Orange',
  },
  {
    main: '#FFEC00',
    image: {
      src: '/content/dam/akzonobel-common/colorWall/RCC_4/Yellow.jpg',
    },
    colors: [
      {
        color: {
          id: '52216',
          hex: '#DD9C2C',
          ccid: '3000902',
          href: '/vi/mau-sac-bang-mau/rich-brocade-20yy-40-608-3000902',
          name: 'Rich Brocade 20YY 40/608',
          title: 'Rich Brocade 20YY 40/608',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000902',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '52606',
          hex: '#DBA000',
          ccid: '3000951',
          href: '/vi/mau-sac-bang-mau/indian-saffron-30yy-41-700-3000951',
          name: 'Indian Saffron 30YY 41/700',
          title: 'Indian Saffron 30YY 41/700',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000951',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '234237',
          hex: '#C39E4B',
          ccid: '2753437',
          href: '/vi/mau-sac-bang-mau/mustard-oil-37yy-39-443-2753437',
          name: 'Mustard Oil 37YY 39/443',
          title: 'Mustard Oil 37YY 39/443',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753437',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '100722',
          hex: '#F8AF1C',
          ccid: '3000907',
          href: '/vi/mau-sac-bang-mau/golden-sun-25yy-49-757-3000907',
          name: 'Golden Sun 25YY 49/757',
          title: 'Golden Sun 25YY 49/757',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000907',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '234187',
          hex: '#F5B700',
          ccid: '2753428',
          href: '/vi/mau-sac-bang-mau/elegant-easter-34yy-55-802-2753428',
          name: 'Elegant Easter 34YY 55/802',
          title: 'Elegant Easter 34YY 55/802',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753428',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '73473',
          hex: '#D7B468',
          ccid: '3000967',
          href: '/vi/mau-sac-bang-mau/triple-crown-40yy-49-408-3000967',
          name: 'Triple Crown 40YY 49/408',
          title: 'Triple Crown 40YY 49/408',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000967',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '234176',
          hex: '#FFCF6E',
          ccid: '3000957',
          href: '/vi/mau-sac-bang-mau/dazzling-dunes-33yy-69-519-3000957',
          name: 'Dazzling Dunes 33YY 69/519',
          title: 'Dazzling Dunes 33YY 69/519',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000957',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '234181',
          hex: '#F9C13B',
          ccid: '3000959',
          href: '/vi/mau-sac-bang-mau/sublime-solar-34yy-61-672-3000959',
          name: 'Sublime Solar 34YY 61/672',
          title: 'Sublime Solar 34YY 61/672',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000959',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '48672',
          hex: '#E6C780',
          ccid: '3000971',
          href: '/vi/mau-sac-bang-mau/victorian-yellow-45yy-61-368-3000971',
          name: 'Victorian Yellow 45YY 61/368',
          title: 'Victorian Yellow 45YY 61/368',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000971',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '234169',
          hex: '#FBD388',
          ccid: '3000960',
          href: '/vi/mau-sac-bang-mau/glow-delight-34yy-71-404-3000960',
          name: 'Glow Delight 34YY 71/404',
          title: 'Glow Delight 34YY 71/404',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000960',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '52630',
          hex: '#F6CF6C',
          ccid: '3000973',
          href: '/vi/mau-sac-bang-mau/essential-yellow-45yy-66-512-3000973',
          name: 'Essential Yellow 45YY 66/512',
          title: 'Essential Yellow 45YY 66/512',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000973',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '48671',
          hex: '#E8CC8D',
          ccid: '3000972',
          href: '/vi/mau-sac-bang-mau/portuguese-sonnet-45yy-65-334-3000972',
          name: 'Portuguese Sonnet 45YY 65/334',
          title: 'Portuguese Sonnet 45YY 65/334',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000972',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '234223',
          hex: '#FEDFA1',
          ccid: '2753445',
          href: '/vi/mau-sac-bang-mau/summer-sentiment-39yy-78-329-2753445',
          name: 'Summer Sentiment 39YY 78/329',
          title: 'Summer Sentiment 39YY 78/329',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753445',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '234312',
          hex: '#FEE089',
          ccid: '3001013',
          href: '/vi/mau-sac-bang-mau/sunrise-lift-51yy-78-444-3001013',
          name: 'Sunrise Lift 51YY 78/444',
          title: 'Sunrise Lift 51YY 78/444',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001013',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '49152',
          hex: '#F2DCAA',
          ccid: '3001010',
          href: '/vi/mau-sac-bang-mau/may-yellow-50yy-75-254-3001010',
          name: 'May Yellow 50YY 75/254',
          title: 'May Yellow 50YY 75/254',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001010',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '234149',
          hex: '#FAEBD1',
          ccid: '2753446',
          href: '/vi/mau-sac-bang-mau/space-sensation-39yy-86-135-2753446',
          name: 'Space Sensation 39YY 86/135',
          title: 'Space Sensation 39YY 86/135',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753446',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '52622',
          hex: '#FBE5AD',
          ccid: '3001016',
          href: '/vi/mau-sac-bang-mau/celestial-sun-54yy-85-291-3001016',
          name: 'Celestial Sun 54YY 85/291',
          title: 'Celestial Sun 54YY 85/291',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001016',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '52654',
          hex: '#F0E1BF',
          ccid: '3001011',
          href: '/vi/mau-sac-bang-mau/boston-cream-50yy-77-173-3001011',
          name: 'Boston Cream 50YY 77/173',
          title: 'Boston Cream 50YY 77/173',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001011',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '234403',
          hex: '#F7F0DF',
          ccid: '2753503',
          href: '/vi/mau-sac-bang-mau/vanilla-sensation-53yy-89-081-2753503',
          name: 'Vanilla Sensation 53YY 89/081',
          title: 'Vanilla Sensation 53YY 89/081',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753503',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '48345',
          hex: '#F7E9C5',
          ccid: '3001021',
          href: '/vi/mau-sac-bang-mau/soft-yellow-58yy-88-180-3001021',
          name: 'Soft Yellow 58YY 88/180',
          title: 'Soft Yellow 58YY 88/180',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001021',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '234722',
          hex: '#F6F1DE',
          ccid: '3001036',
          href: '/vi/mau-sac-bang-mau/glowing-moon-65yy-89-088-3001036',
          name: 'Glowing Moon 65YY 89/088',
          title: 'Glowing Moon 65YY 89/088',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001036',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '259146',
          hex: '#EDE8DD',
          ccid: '3000963',
          href: '/vi/mau-sac-bang-mau/egret-39yy-85-046-3000963',
          name: 'Egret 39YY 85/046',
          title: 'Egret 39YY 85/046',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000963',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '119841',
          hex: '#F4E9D6',
          ccid: '3000962',
          href: '/vi/mau-sac-bang-mau/ivory-fantasy-39yy-84-095-3000962',
          name: 'Ivory Fantasy 39YY 84/095',
          title: 'Ivory Fantasy 39YY 84/095',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000962',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '234822',
          hex: '#F2F1E5',
          ccid: '2753602',
          href: '/vi/mau-sac-bang-mau/cotton-fantasy-83yy-89-055-2753602',
          name: 'Cotton Fantasy 83YY 89/055',
          title: 'Cotton Fantasy 83YY 89/055',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753602',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '13094',
          hex: '#F0EDE4',
          ccid: '3001018',
          href: '/vi/mau-sac-bang-mau/cotton-breeze-56yy-87-037-3001018',
          name: 'Cotton Breeze 56YY 87/037',
          title: 'Cotton Breeze 56YY 87/037',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001018',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '234871',
          hex: '#F1F0E8',
          ccid: '2753601',
          href: '/vi/mau-sac-bang-mau/clinic-white-83yy-88-033-2753601',
          name: 'Clinic White 83YY 88/033',
          title: 'Clinic White 83YY 88/033',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753601',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '100887',
          hex: '#ECE9E0',
          ccid: '3001063',
          href: '/vi/mau-sac-bang-mau/wedding-white-70yy-83-037-3001063',
          name: 'Wedding White 70YY 83/037',
          title: 'Wedding White 70YY 83/037',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001063',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '616416',
          hex: '#F1E7D3',
          ccid: '3000974',
          href: '/vi/mau-sac-bang-mau/neutral-garden-45yy-82-098-3000974',
          name: 'Neutral Garden 45YY 82/098',
          title: 'Neutral Garden 45YY 82/098',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000974',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '234326',
          hex: '#E7E1D4',
          ccid: '2753500',
          href: '/vi/mau-sac-bang-mau/precious-spring-53yy-77-064-2753500',
          name: 'Precious Spring 53YY 77/064',
          title: 'Precious Spring 53YY 77/064',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753500',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '49601',
          hex: '#DEDCD7',
          ccid: '3000954',
          href: '/vi/mau-sac-bang-mau/pelican-30yy-72-018-3000954',
          name: 'Pelican 30YY 72/018',
          title: 'Pelican 30YY 72/018',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000954',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '234196',
          hex: '#ECDFCA',
          ccid: '2753430',
          href: '/vi/mau-sac-bang-mau/mustard-sky-35yy-76-110-2753430',
          name: 'Mustard Sky 35YY 76/110',
          title: 'Mustard Sky 35YY 76/110',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753430',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '234334',
          hex: '#E1DACA',
          ccid: '2753466',
          href: '/vi/mau-sac-bang-mau/cloud-sand-45yy-73-081-2753466',
          name: 'Cloud Sand 45YY 73/081',
          title: 'Cloud Sand 45YY 73/081',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753466',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '862',
          hex: '#CECCC3',
          ccid: '3000970',
          href: '/vi/mau-sac-bang-mau/city-life-44yy-65-034-3000970',
          name: 'City Life 44YY 65/034',
          title: 'City Life 44YY 65/034',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000970',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '49111',
          hex: '#DFCCB1',
          ccid: '3000953',
          href: '/vi/mau-sac-bang-mau/oyster-white-30yy-64-149-3000953',
          name: 'Oyster White 30YY 64/149',
          title: 'Oyster White 30YY 64/149',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000953',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '259276',
          hex: '#DDD3C2',
          ccid: '3000969',
          href: '/vi/mau-sac-bang-mau/pillar-40yy-67-087-3000969',
          name: 'Pillar 40YY 67/087',
          title: 'Pillar 40YY 67/087',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000969',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '234190',
          hex: '#C4BDB0',
          ccid: '2753443',
          href: '/vi/mau-sac-bang-mau/grey-feather-39yy-53-067-2753443',
          name: 'Grey Feather 39YY 53/067',
          title: 'Grey Feather 39YY 53/067',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753443',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '49112',
          hex: '#D9C3A4',
          ccid: '3000952',
          href: '/vi/mau-sac-bang-mau/ivory-sampler-30yy-58-178-3000952',
          name: 'Ivory Sampler 30YY 58/178',
          title: 'Ivory Sampler 30YY 58/178',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000952',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '234102',
          hex: '#CCBDA6',
          ccid: '2753413',
          href: '/vi/mau-sac-bang-mau/olive-walls-30yy-53-124-2753413',
          name: 'Olive Walls 30YY 53/124',
          title: 'Olive Walls 30YY 53/124',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753413',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '49797',
          hex: '#C1B8A8',
          ccid: '3000968',
          href: '/vi/mau-sac-bang-mau/burmese-beige-40yy-51-084-3000968',
          name: 'Burmese Beige 40YY 51/084',
          title: 'Burmese Beige 40YY 51/084',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000968',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '101029',
          hex: '#BD9F7B',
          ccid: '3000901',
          href: '/vi/mau-sac-bang-mau/sable-sands-20yy-38-225-3000901',
          name: 'Sable Sands 20YY 38/225',
          title: 'Sable Sands 20YY 38/225',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000901',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '234019',
          hex: '#A79278',
          ccid: '2753380',
          href: '/vi/mau-sac-bang-mau/twisted-twig-22yy-32-156-2753380',
          name: 'Twisted Twig 22YY 32/156',
          title: 'Twisted Twig 22YY 32/156',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753380',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '49799',
          hex: '#AFA490',
          ccid: '3000966',
          href: '/vi/mau-sac-bang-mau/potter-s-clay-40yy-38-107-3000966',
          name: "Potter's Clay 40YY 38/107",
          title: "Potter's Clay 40YY 38/107",
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000966',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '74159',
          hex: '#7D623B',
          ccid: '3000899',
          href: '/vi/mau-sac-bang-mau/westchester-gold-20yy-15-245-3000899',
          name: 'Westchester Gold 20YY 15/245',
          title: 'Westchester Gold 20YY 15/245',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000899',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '49760',
          hex: '#8B7A66',
          ccid: '3000900',
          href: '/vi/mau-sac-bang-mau/hale-village-20yy-22-129-3000900',
          name: 'Hale Village 20YY 22/129',
          title: 'Hale Village 20YY 22/129',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000900',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '49919',
          hex: '#8A8376',
          ccid: '3000965',
          href: '/vi/mau-sac-bang-mau/grey-mountain-40yy-25-074-3000965',
          name: 'Grey Mountain 40YY 25/074',
          title: 'Grey Mountain 40YY 25/074',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000965',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '49698',
          hex: '#634F35',
          ccid: '3000898',
          href: '/vi/mau-sac-bang-mau/turkish-brown-20yy-09-175-3000898',
          name: 'Turkish Brown 20YY 09/175',
          title: 'Turkish Brown 20YY 09/175',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000898',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '49913',
          hex: '#52483B',
          ccid: '3000950',
          href: '/vi/mau-sac-bang-mau/burnt-bark-30yy-08-082-3000950',
          name: 'Burnt Bark 30YY 08/082',
          title: 'Burnt Bark 30YY 08/082',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000950',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '233948',
          hex: '#53504D',
          ccid: '2753370',
          href: '/vi/mau-sac-bang-mau/storm-bird-20yy-11-017-2753370',
          name: 'Storm Bird 20YY 11/017',
          title: 'Storm Bird 20YY 11/017',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753370',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
    ],
    hueName: 'Yellow',
  },
  {
    main: '#B7CE0D',
    image: {
      src: '/content/dam/akzonobel-common/colorWall/RCC_4/Lime.jpg',
    },
    colors: [
      {
        color: {
          id: '100970',
          hex: '#B0993F',
          ccid: '3001023',
          href: '/vi/mau-sac-bang-mau/chrome-primrose-60yy-34-461-3001023',
          name: 'Chrome Primrose 60YY 34/461',
          title: 'Chrome Primrose 60YY 34/461',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001023',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '234956',
          hex: '#888C29',
          ccid: '3001091',
          href: '/vi/mau-sac-bang-mau/leprechaun-leap-87yy-26-456-3001091',
          name: 'Leprechaun Leap 87YY 26/456',
          title: 'Leprechaun Leap 87YY 26/456',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001091',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '53172',
          hex: '#777B5B',
          ccid: '3000860',
          href: '/vi/mau-sac-bang-mau/guild-green-10gy-20-179-3000860',
          name: 'Guild Green 10GY 20/179',
          title: 'Guild Green 10GY 20/179',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000860',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '52662',
          hex: '#C4A91B',
          ccid: '3001024',
          href: '/vi/mau-sac-bang-mau/shasta-60yy-39-654-3001024',
          name: 'Shasta 60YY 39/654',
          title: 'Shasta 60YY 39/654',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001024',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '234957',
          hex: '#A4A93A',
          ccid: '3001093',
          href: '/vi/mau-sac-bang-mau/tennis-lawn-88yy-38-530-3001093',
          name: 'Tennis Lawn 88YY 38/530',
          title: 'Tennis Lawn 88YY 38/530',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001093',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '235073',
          hex: '#838A65',
          ccid: '2753310',
          href: '/vi/mau-sac-bang-mau/cabin-green-08gy-26-190-2753310',
          name: 'Cabin Green 08GY 26/190',
          title: 'Cabin Green 08GY 26/190',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753310',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '234445',
          hex: '#E0BA25',
          ccid: '3001009',
          href: '/vi/mau-sac-bang-mau/sulphur-burst-50yy-53-687-3001009',
          name: 'Sulphur Burst 50YY 53/687',
          title: 'Sulphur Burst 50YY 53/687',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001009',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '52688',
          hex: '#B9BB58',
          ccid: '3001118',
          href: '/vi/mau-sac-bang-mau/english-apple-90yy-48-500-3001118',
          name: 'English Apple 90YY 48/500',
          title: 'English Apple 90YY 48/500',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001118',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '52708',
          hex: '#A3AC74',
          ccid: '3000861',
          href: '/vi/mau-sac-bang-mau/precious-jasper-10gy-40-296-3000861',
          name: 'Precious Jasper 10GY 40/296',
          title: 'Precious Jasper 10GY 40/296',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000861',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '52640',
          hex: '#F3D15B',
          ccid: '3001025',
          href: '/vi/mau-sac-bang-mau/electric-avenue-60yy-69-583-3001025',
          name: 'Electric Avenue 60YY 69/583',
          title: 'Electric Avenue 60YY 69/583',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001025',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '234761',
          hex: '#CCC45A',
          ccid: '3001073',
          href: '/vi/mau-sac-bang-mau/fantasy-garden-75yy-55-509-3001073',
          name: 'Fantasy Garden 75YY 55/509',
          title: 'Fantasy Garden 75YY 55/509',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001073',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '235016',
          hex: '#BEC198',
          ccid: '3001125',
          href: '/vi/mau-sac-bang-mau/mountain-hike-96yy-53-200-3001125',
          name: 'Mountain Hike 96YY 53/200',
          title: 'Mountain Hike 96YY 53/200',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001125',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '48697',
          hex: '#EFD886',
          ccid: '3001026',
          href: '/vi/mau-sac-bang-mau/rich-yellow-60yy-71-409-3001026',
          name: 'Rich Yellow 60YY 71/409',
          title: 'Rich Yellow 60YY 71/409',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001026',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '48364',
          hex: '#E0DD90',
          ccid: '3001094',
          href: '/vi/mau-sac-bang-mau/grecian-green-88yy-71-380-3001094',
          name: 'Grecian Green 88YY 71/380',
          title: 'Grecian Green 88YY 71/380',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001094',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '234993',
          hex: '#D5D6B5',
          ccid: '2753639',
          href: '/vi/mau-sac-bang-mau/juicy-pear-94yy-67-164-2753639',
          name: 'Juicy Pear 94YY 67/164',
          title: 'Juicy Pear 94YY 67/164',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753639',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '234595',
          hex: '#F1E4B8',
          ccid: '3001033',
          href: '/vi/mau-sac-bang-mau/yellow-kiwi-63yy-79-219-3001033',
          name: 'Yellow Kiwi 63YY 79/219',
          title: 'Yellow Kiwi 63YY 79/219',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001033',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '48363',
          hex: '#E8E5AE',
          ccid: '3001095',
          href: '/vi/mau-sac-bang-mau/lime-twist-89yy-78-269-3001095',
          name: 'Lime Twist 89YY 78/269',
          title: 'Lime Twist 89YY 78/269',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001095',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '52701',
          hex: '#E6EACB',
          ccid: '3000863',
          href: '/vi/mau-sac-bang-mau/meadow-mist-10gy-83-150-3000863',
          name: 'Meadow Mist 10GY 83/150',
          title: 'Meadow Mist 10GY 83/150',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000863',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '234920',
          hex: '#EEEDD5',
          ccid: '3001092',
          href: '/vi/mau-sac-bang-mau/forest-touch-87yy-85-110-3001092',
          name: 'Forest Touch 87YY 85/110',
          title: 'Forest Touch 87YY 85/110',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001092',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '100978',
          hex: '#EDE9C5',
          ccid: '3001119',
          href: '/vi/mau-sac-bang-mau/spring-thaw-90yy-83-179-3001119',
          name: 'Spring Thaw 90YY 83/179',
          title: 'Spring Thaw 90YY 83/179',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001119',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '49559',
          hex: '#E7E7D1',
          ccid: '3000862',
          href: '/vi/mau-sac-bang-mau/springwater-10gy-83-100-3000862',
          name: 'Springwater 10GY 83/100',
          title: 'Springwater 10GY 83/100',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000862',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '616368',
          hex: '#F0EEE5',
          ccid: '3001035',
          href: '/vi/mau-sac-bang-mau/frosty-feeling-65yy-87-039-3001035',
          name: 'Frosty Feeling 65YY 87/039',
          title: 'Frosty Feeling 65YY 87/039',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001035',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '234985',
          hex: '#F0F0E0',
          ccid: '2753632',
          href: '/vi/mau-sac-bang-mau/eggshell-sheen-91yy-88-072-2753632',
          name: 'Eggshell Sheen 91YY 88/072',
          title: 'Eggshell Sheen 91YY 88/072',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753632',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '235012',
          hex: '#E9EAD7',
          ccid: '2753649',
          href: '/vi/mau-sac-bang-mau/watery-willow-97yy-83-090-2753649',
          name: 'Watery Willow 97YY 83/090',
          title: 'Watery Willow 97YY 83/090',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753649',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '234479',
          hex: '#F6F2E5',
          ccid: '2753538',
          href: '/vi/mau-sac-bang-mau/polar-heights-65yy-90-062-2753538',
          name: 'Polar Heights 65YY 90/062',
          title: 'Polar Heights 65YY 90/062',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753538',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '234869',
          hex: '#EEEDE5',
          ccid: '3001076',
          href: '/vi/mau-sac-bang-mau/mellow-snow-77yy-86-032-3001076',
          name: 'Mellow Snow 77YY 86/032',
          title: 'Mellow Snow 77YY 86/032',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001076',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '235167',
          hex: '#E7E6DD',
          ccid: '2753623',
          href: '/vi/mau-sac-bang-mau/eternal-snowdrop-89yy-80-039-2753623',
          name: 'Eternal Snowdrop 89YY 80/039',
          title: 'Eternal Snowdrop 89YY 80/039',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753623',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '234399',
          hex: '#E3DDCF',
          ccid: '3001012',
          href: '/vi/mau-sac-bang-mau/inspiring-morning-51yy-74-066-3001012',
          name: 'Inspiring Morning 51YY 74/066',
          title: 'Inspiring Morning 51YY 74/066',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001012',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '234579',
          hex: '#DEDACB',
          ccid: '2753536',
          href: '/vi/mau-sac-bang-mau/mushroom-morning-65yy-71-071-2753536',
          name: 'Mushroom Morning 65YY 71/071',
          title: 'Mushroom Morning 65YY 71/071',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753536',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '235166',
          hex: '#DEDDD3',
          ccid: '2753586',
          href: '/vi/mau-sac-bang-mau/grey-dunes-81yy-73-041-2753586',
          name: 'Grey Dunes 81YY 73/041',
          title: 'Grey Dunes 81YY 73/041',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753586',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '234528',
          hex: '#E8E1CB',
          ccid: '2753523',
          href: '/vi/mau-sac-bang-mau/city-morning-61yy-76-109-2753523',
          name: 'City Morning 61YY 76/109',
          title: 'City Morning 61YY 76/109',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753523',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '234400',
          hex: '#D3CDBE',
          ccid: '2753509',
          href: '/vi/mau-sac-bang-mau/river-revolution-54yy-63-072-2753509',
          name: 'River Revolution 54YY 63/072',
          title: 'River Revolution 54YY 63/072',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753509',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '235162',
          hex: '#D3D3CB',
          ccid: '2753647',
          href: '/vi/mau-sac-bang-mau/grey-chic-96yy-66-036-2753647',
          name: 'Grey Chic 96YY 66/036',
          title: 'Grey Chic 96YY 66/036',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753647',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '234462',
          hex: '#E6D9B7',
          ccid: '2753511',
          href: '/vi/mau-sac-bang-mau/dune-sensation-54yy-71-171-2753511',
          name: 'Dune Sensation 54YY 71/171',
          title: 'Dune Sensation 54YY 71/171',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753511',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '49216',
          hex: '#CBC5B1',
          ccid: '3001062',
          href: '/vi/mau-sac-bang-mau/distant-mountain-70yy-57-098-3001062',
          name: 'Distant Mountain 70YY 57/098',
          title: 'Distant Mountain 70YY 57/098',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001062',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '234983',
          hex: '#C0C1B5',
          ccid: '2753656',
          href: '/vi/mau-sac-bang-mau/furry-flush-99yy-55-056-2753656',
          name: 'Furry Flush 99YY 55/056',
          title: 'Furry Flush 99YY 55/056',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753656',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '234350',
          hex: '#DBCAA4',
          ccid: '2753468',
          href: '/vi/mau-sac-bang-mau/taupe-sheen-46yy-61-201-2753468',
          name: 'Taupe Sheen 46YY 61/201',
          title: 'Taupe Sheen 46YY 61/201',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753468',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '234588',
          hex: '#AAA48F',
          ccid: '3001034',
          href: '/vi/mau-sac-bang-mau/olive-wash-64yy-39-108-3001034',
          name: 'Olive Wash 64YY 39/108',
          title: 'Olive Wash 64YY 39/108',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001034',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '234877',
          hex: '#B2B1A5',
          ccid: '2753598',
          href: '/vi/mau-sac-bang-mau/grey-calm-83yy-45-055-2753598',
          name: 'Grey Calm 83YY 45/055',
          title: 'Grey Calm 83YY 45/055',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753598',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '234355',
          hex: '#B6A379',
          ccid: '2753472',
          href: '/vi/mau-sac-bang-mau/mustard-mud-47yy-40-227-2753472',
          name: 'Mustard Mud 47YY 40/227',
          title: 'Mustard Mud 47YY 40/227',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753472',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '100975',
          hex: '#918A70',
          ccid: '3001061',
          href: '/vi/mau-sac-bang-mau/palo-verde-70yy-26-137-3001061',
          name: 'Palo Verde 70YY 26/137',
          title: 'Palo Verde 70YY 26/137',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001061',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '234917',
          hex: '#949488',
          ccid: '2753630',
          href: '/vi/mau-sac-bang-mau/team-grey-91yy-31-059-2753630',
          name: 'Team Grey 91YY 31/059',
          title: 'Team Grey 91YY 31/059',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753630',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '234423',
          hex: '#938564',
          ccid: '2753483',
          href: '/vi/mau-sac-bang-mau/lakeside-town-49yy-26-180-2753483',
          name: 'Lakeside Town 49YY 26/180',
          title: 'Lakeside Town 49YY 26/180',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753483',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '100976',
          hex: '#787256',
          ccid: '3001060',
          href: '/vi/mau-sac-bang-mau/green-grove-70yy-18-152-3001060',
          name: 'Green Grove 70YY 18/152',
          title: 'Green Grove 70YY 18/152',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001060',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '49809',
          hex: '#747264',
          ccid: '3001117',
          href: '/vi/mau-sac-bang-mau/english-pinewood-90yy-19-075-3001117',
          name: 'English Pinewood 90YY 19/075',
          title: 'English Pinewood 90YY 19/075',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001117',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '234359',
          hex: '#625841',
          ccid: '3000976',
          href: '/vi/mau-sac-bang-mau/forest-ground-48yy-12-123-3000976',
          name: 'Forest Ground 48YY 12/123',
          title: 'Forest Ground 48YY 12/123',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000976',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '49221',
          hex: '#5A5335',
          ccid: '3001059',
          href: '/vi/mau-sac-bang-mau/forest-floor-70yy-09-175-3001059',
          name: 'Forest Floor 70YY 09/175',
          title: 'Forest Floor 70YY 09/175',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001059',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '235088',
          hex: '#4C4E48',
          ccid: '2753409',
          href: '/vi/mau-sac-bang-mau/slate-dream-29gy-10-029-2753409',
          name: 'Slate Dream 29GY 10/029',
          title: 'Slate Dream 29GY 10/029',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753409',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
    ],
    hueName: 'Lime',
  },
  {
    main: '#3F993F',
    image: {
      src: '/content/dam/akzonobel-common/colorWall/RCC_4/Green.jpg',
    },
    colors: [
      {
        color: {
          id: '52745',
          hex: '#527143',
          ccid: '3000995',
          href: '/vi/mau-sac-bang-mau/splendor-50gy-15-289-3000995',
          name: 'Splendor 50GY 15/289',
          title: 'Splendor 50GY 15/289',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000995',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '235527',
          hex: '#32583D',
          ccid: '3001089',
          href: '/vi/mau-sac-bang-mau/everglade-song-85gy-10-193-3001089',
          name: 'Everglade Song 85GY 10/193',
          title: 'Everglade Song 85GY 10/193',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001089',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '52264',
          hex: '#19563E',
          ccid: '3000839',
          href: '/vi/mau-sac-bang-mau/forest-green-07gg-08-244-3000839',
          name: 'Forest Green 07GG 08/244',
          title: 'Forest Green 07GG 08/244',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000839',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '52726',
          hex: '#648637',
          ccid: '3000931',
          href: '/vi/mau-sac-bang-mau/market-green-30gy-21-429-3000931',
          name: 'Market Green 30GY 21/429',
          title: 'Market Green 30GY 21/429',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000931',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '100915',
          hex: '#34794D',
          ccid: '3001105',
          href: '/vi/mau-sac-bang-mau/amazon-leaf-90gy-16-354-3001105',
          name: 'Amazon Leaf 90GY 16/354',
          title: 'Amazon Leaf 90GY 16/354',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001105',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '52249',
          hex: '#238E52',
          ccid: '3001106',
          href: '/vi/mau-sac-bang-mau/treehouse-90gy-21-472-3001106',
          name: 'Treehouse 90GY 21/472',
          title: 'Treehouse 90GY 21/472',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001106',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '235138',
          hex: '#95A969',
          ccid: '3000894',
          href: '/vi/mau-sac-bang-mau/tranquil-orchard-18gy-38-328-3000894',
          name: 'Tranquil Orchard 18GY 38/328',
          title: 'Tranquil Orchard 18GY 38/328',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000894',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '48768',
          hex: '#7EB17E',
          ccid: '3001047',
          href: '/vi/mau-sac-bang-mau/grassroots-70gy-38-330-3001047',
          name: 'Grassroots 70GY 38/330',
          title: 'Grassroots 70GY 38/330',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001047',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '100748',
          hex: '#57A972',
          ccid: '3001107',
          href: '/vi/mau-sac-bang-mau/grand-highland-90gy-33-408-3001107',
          name: 'Grand Highland 90GY 33/408',
          title: 'Grand Highland 90GY 33/408',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001107',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '73496',
          hex: '#AAC089',
          ccid: '3000932',
          href: '/vi/mau-sac-bang-mau/caledon-hills-30gy-51-294-3000932',
          name: 'Caledon Hills 30GY 51/294',
          title: 'Caledon Hills 30GY 51/294',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000932',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '235427',
          hex: '#A5CEA7',
          ccid: '3001067',
          href: '/vi/mau-sac-bang-mau/jade-sensation-73gy-56-241-3001067',
          name: 'Jade Sensation 73GY 56/241',
          title: 'Jade Sensation 73GY 56/241',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001067',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '100913',
          hex: '#93C1A1',
          ccid: '3001108',
          href: '/vi/mau-sac-bang-mau/pixie-palace-90gy-48-234-3001108',
          name: 'Pixie Palace 90GY 48/234',
          title: 'Pixie Palace 90GY 48/234',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001108',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '52723',
          hex: '#BFD1A3',
          ccid: '3000933',
          href: '/vi/mau-sac-bang-mau/miami-grass-30gy-61-245-3000933',
          name: 'Miami Grass 30GY 61/245',
          title: 'Miami Grass 30GY 61/245',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000933',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '73153',
          hex: '#BAD9B8',
          ccid: '3001048',
          href: '/vi/mau-sac-bang-mau/french-green-70gy-66-200-3001048',
          name: 'French Green 70GY 66/200',
          title: 'French Green 70GY 66/200',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001048',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '100911',
          hex: '#BEDAC4',
          ccid: '3001109',
          href: '/vi/mau-sac-bang-mau/victoria-green-90gy-67-146-3001109',
          name: 'Victoria Green 90GY 67/146',
          title: 'Victoria Green 90GY 67/146',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001109',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '48728',
          hex: '#D2E0BB',
          ccid: '3000934',
          href: '/vi/mau-sac-bang-mau/venetian-glass-30gy-72-196-3000934',
          name: 'Venetian Glass 30GY 72/196',
          title: 'Venetian Glass 30GY 72/196',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000934',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '100903',
          hex: '#CCE3C9',
          ccid: '3001049',
          href: '/vi/mau-sac-bang-mau/marine-glow-70gy-74-149-3001049',
          name: 'Marine Glow 70GY 74/149',
          title: 'Marine Glow 70GY 74/149',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001049',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '235477',
          hex: '#D0E4D2',
          ccid: '2753590',
          href: '/vi/mau-sac-bang-mau/grasshopper-spring-82gy-75-111-2753590',
          name: 'Grasshopper Spring 82GY 75/111',
          title: 'Grasshopper Spring 82GY 75/111',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753590',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '52722',
          hex: '#E5EBD5',
          ccid: '3000936',
          href: '/vi/mau-sac-bang-mau/green-satin-30gy-83-107-3000936',
          name: 'Green Satin 30GY 83/107',
          title: 'Green Satin 30GY 83/107',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000936',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '52750',
          hex: '#E0ECDD',
          ccid: '3001050',
          href: '/vi/mau-sac-bang-mau/mint-hint-70gy-83-080-3001050',
          name: 'Mint Hint 70GY 83/080',
          title: 'Mint Hint 70GY 83/080',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001050',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '100910',
          hex: '#DAEDDC',
          ccid: '3001111',
          href: '/vi/mau-sac-bang-mau/cameo-green-90gy-83-098-3001111',
          name: 'Cameo Green 90GY 83/098',
          title: 'Cameo Green 90GY 83/098',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001111',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '49563',
          hex: '#E7EAE0',
          ccid: '3000935',
          href: '/vi/mau-sac-bang-mau/morning-hush-30gy-83-043-3000935',
          name: 'Morning Hush 30GY 83/043',
          title: 'Morning Hush 30GY 83/043',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000935',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '49572',
          hex: '#E6EAE4',
          ccid: '3000859',
          href: '/vi/mau-sac-bang-mau/snowbank-10gg-83-018-3000859',
          name: 'Snowbank 10GG 83/018',
          title: 'Snowbank 10GG 83/018',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000859',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '235543',
          hex: '#E5EEE4',
          ccid: '2753576',
          href: '/vi/mau-sac-bang-mau/chinese-whisper-80gy-85-051-2753576',
          name: 'Chinese Whisper 80GY 85/051',
          title: 'Chinese Whisper 80GY 85/051',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753576',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '49598',
          hex: '#EEEFEA',
          ccid: '3000937',
          href: '/vi/mau-sac-bang-mau/white-on-white-30gy-88-014-3000937',
          name: 'White on White 30GY 88/014',
          title: 'White on White 30GY 88/014',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000937',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '235303',
          hex: '#EEEFE8',
          ccid: '2753290',
          href: '/vi/mau-sac-bang-mau/elegant-cotton-04gy-87-028-2753290',
          name: 'Elegant Cotton 04GY 87/028',
          title: 'Elegant Cotton 04GY 87/028',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753290',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '49586',
          hex: '#E7EAE6',
          ccid: '3000991',
          href: '/vi/mau-sac-bang-mau/winter-s-day-50gg-83-011-3000991',
          name: "Winter's Day 50GG 83/011",
          title: "Winter's Day 50GG 83/011",
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000991',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '265324',
          hex: '#E6E9E3',
          ccid: '3001031',
          href: '/vi/mau-sac-bang-mau/wish-upon-a-star-63gy-83-021-3001031',
          name: 'Wish Upon a Star 63GY 83/021',
          title: 'Wish Upon a Star 63GY 83/021',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001031',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '235160',
          hex: '#ECEDE7',
          ccid: '3000880',
          href: '/vi/mau-sac-bang-mau/dewdrop-grey-11gy-85-016-3000880',
          name: 'Dewdrop Grey 11GY 85/016',
          title: 'Dewdrop Grey 11GY 85/016',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000880',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '53200',
          hex: '#D5DAD5',
          ccid: '3000858',
          href: '/vi/mau-sac-bang-mau/chelsea-fog-10gg-72-022-3000858',
          name: 'Chelsea Fog 10GG 72/022',
          title: 'Chelsea Fog 10GG 72/022',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000858',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '266052',
          hex: '#E3E9E1',
          ccid: '3001110',
          href: '/vi/mau-sac-bang-mau/glacier-lake-90gy-82-028-3001110',
          name: 'Glacier Lake 90GY 82/028',
          title: 'Glacier Lake 90GY 82/028',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001110',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '235307',
          hex: '#DCDFD8',
          ccid: '2753441',
          href: '/vi/mau-sac-bang-mau/lake-of-grey-39gy-75-033-2753441',
          name: 'Lake of Grey 39GY 75/033',
          title: 'Lake of Grey 39GY 75/033',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753441',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '235668',
          hex: '#CDD4CE',
          ccid: '2753638',
          href: '/vi/mau-sac-bang-mau/blurry-grey-94gy-66-038-2753638',
          name: 'Blurry Grey 94GY 66/038',
          title: 'Blurry Grey 94GY 66/038',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753638',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '235056',
          hex: '#D0D4C3',
          ccid: '2753353',
          href: '/vi/mau-sac-bang-mau/public-park-16gy-66-078-2753353',
          name: 'Public Park 16GY 66/078',
          title: 'Public Park 16GY 66/078',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753353',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '235244',
          hex: '#BDC3B9',
          ccid: '2753461',
          href: '/vi/mau-sac-bang-mau/grey-jeans-45gy-55-052-2753461',
          name: 'Grey Jeans 45GY 55/052',
          title: 'Grey Jeans 45GY 55/052',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753461',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '235512',
          hex: '#B5BBB5',
          ccid: '3001080',
          href: '/vi/mau-sac-bang-mau/silver-sensation-80gy-50-031-3001080',
          name: 'Silver Sensation 80GY 50/031',
          title: 'Silver Sensation 80GY 50/031',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001080',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '235127',
          hex: '#A3A793',
          ccid: '3000885',
          href: '/vi/mau-sac-bang-mau/sheer-stone-12gy-39-101-3000885',
          name: 'Sheer Stone 12GY 39/101',
          title: 'Sheer Stone 12GY 39/101',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000885',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '235172',
          hex: '#AFB3A5',
          ccid: '2753369',
          href: '/vi/mau-sac-bang-mau/kaki-daylight-20gy-46-067-2753369',
          name: 'Kaki Daylight 20GY 46/067',
          title: 'Kaki Daylight 20GY 46/067',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753369',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '100919',
          hex: '#9DA5A0',
          ccid: '3000856',
          href: '/vi/mau-sac-bang-mau/pepper-tree-10gg-38-038-3000856',
          name: 'Pepper Tree 10GG 38/038',
          title: 'Pepper Tree 10GG 38/038',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000856',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '235175',
          hex: '#858A77',
          ccid: '3000893',
          href: '/vi/mau-sac-bang-mau/forest-fantasy-17gy-27-098-3000893',
          name: 'Forest Fantasy 17GY 27/098',
          title: 'Forest Fantasy 17GY 27/098',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000893',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '235313',
          hex: '#7B8178',
          ccid: '2753493',
          href: '/vi/mau-sac-bang-mau/mouse-tail-52gy-24-050-2753493',
          name: 'Mouse Tail 52GY 24/050',
          title: 'Mouse Tail 52GY 24/050',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753493',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '235665',
          hex: '#7F847F',
          ccid: '3001123',
          href: '/vi/mau-sac-bang-mau/otter-silver-93gy-24-024-3001123',
          name: 'Otter Silver 93GY 24/024',
          title: 'Otter Silver 93GY 24/024',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001123',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '235129',
          hex: '#575A4C',
          ccid: '3000879',
          href: '/vi/mau-sac-bang-mau/gorgeous-olive-11gy-12-072-3000879',
          name: 'Gorgeous Olive 11GY 12/072',
          title: 'Gorgeous Olive 11GY 12/072',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000879',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '235434',
          hex: '#616760',
          ccid: '3001069',
          href: '/vi/mau-sac-bang-mau/metallic-touch-74gy-15-043-3001069',
          name: 'Metallic Touch 74GY 15/043',
          title: 'Metallic Touch 74GY 15/043',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001069',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '235663',
          hex: '#646967',
          ccid: '3001014',
          href: '/vi/mau-sac-bang-mau/metal-clasp-54gg-16-017-3001014',
          name: 'Metal Clasp 54GG 16/017',
          title: 'Metal Clasp 54GG 16/017',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001014',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '235110',
          hex: '#4F5342',
          ccid: '3000884',
          href: '/vi/mau-sac-bang-mau/grey-forest-12gy-10-087-3000884',
          name: 'Grey Forest 12GY 10/087',
          title: 'Grey Forest 12GY 10/087',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000884',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '49818',
          hex: '#384137',
          ccid: '3000994',
          href: '/vi/mau-sac-bang-mau/black-swan-50gy-06-077-3000994',
          name: 'Black Swan 50GY 06/077',
          title: 'Black Swan 50GY 06/077',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000994',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '235395',
          hex: '#4F514D',
          ccid: '3001028',
          href: '/vi/mau-sac-bang-mau/tarnished-iron-61gy-11-019-3001028',
          name: 'Tarnished Iron 61GY 11/019',
          title: 'Tarnished Iron 61GY 11/019',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001028',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
    ],
    hueName: 'Green',
  },
  {
    main: '#2FAF9F',
    image: {
      src: '/content/dam/akzonobel-common/colorWall/RCC_4/Teal.jpg',
    },
    colors: [
      {
        color: {
          id: '235871',
          hex: '#1C4741',
          ccid: '3001027',
          href: '/vi/mau-sac-bang-mau/dragon-feel-61gg-08-119-3001027',
          name: 'Dragon Feel 61GG 08/119',
          title: 'Dragon Feel 61GG 08/119',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001027',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '235929',
          hex: '#004641',
          ccid: '3001064',
          href: '/vi/mau-sac-bang-mau/energizing-emerald-71gg-07-179-3001064',
          name: 'Energizing Emerald 71GG 07/179',
          title: 'Energizing Emerald 71GG 07/179',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001064',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '236217',
          hex: '#006872',
          ccid: '2753351',
          href: '/vi/mau-sac-bang-mau/intense-caribbean-16bg-13-282-2753351',
          name: 'Intense Caribbean 16BG 13/282',
          title: 'Intense Caribbean 16BG 13/282',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753351',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '100933',
          hex: '#517367',
          ccid: '3000927',
          href: '/vi/mau-sac-bang-mau/soft-fauna-30gg-16-137-3000927',
          name: 'Soft Fauna 30GG 16/137',
          title: 'Soft Fauna 30GG 16/137',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000927',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '52292',
          hex: '#007067',
          ccid: '3001046',
          href: '/vi/mau-sac-bang-mau/zodiac-night-70gg-13-323-3001046',
          name: 'Zodiac Night 70GG 13/323',
          title: 'Zodiac Night 70GG 13/323',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001046',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '236238',
          hex: '#0098A4',
          ccid: '3000892',
          href: '/vi/mau-sac-bang-mau/marine-miracle-16bg-27-325-3000892',
          name: 'Marine Miracle 16BG 27/325',
          title: 'Marine Miracle 16BG 27/325',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000892',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '235626',
          hex: '#64907A',
          ccid: '3000878',
          href: '/vi/mau-sac-bang-mau/pea-wall-11gg-26-195-3000878',
          name: 'Pea Wall 11GG 26/195',
          title: 'Pea Wall 11GG 26/195',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000878',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '48415',
          hex: '#008C86',
          ccid: '3001079',
          href: '/vi/mau-sac-bang-mau/deep-pool-78gg-21-381-3001079',
          name: 'Deep Pool 78GG 21/381',
          title: 'Deep Pool 78GG 21/381',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001079',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '52872',
          hex: '#63B3B9',
          ccid: '3000851',
          href: '/vi/mau-sac-bang-mau/vista-marine-10bg-39-244-3000851',
          name: 'Vista Marine 10BG 39/244',
          title: 'Vista Marine 10BG 39/244',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000851',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '49298',
          hex: '#8CAC9B',
          ccid: '3000857',
          href: '/vi/mau-sac-bang-mau/trinidad-10gg-39-152-3000857',
          name: 'Trinidad 10GG 39/152',
          title: 'Trinidad 10GG 39/152',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000857',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '235993',
          hex: '#6DB0AC',
          ccid: '2753574',
          href: '/vi/mau-sac-bang-mau/crystal-sensation-80gg-39-220-2753574',
          name: 'Crystal Sensation 80GG 39/220',
          title: 'Crystal Sensation 80GG 39/220',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753574',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '100951',
          hex: '#90CCD0',
          ccid: '3000852',
          href: '/vi/mau-sac-bang-mau/bonar-blue-10bg-54-199-3000852',
          name: 'Bonar Blue 10BG 54/199',
          title: 'Bonar Blue 10BG 54/199',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000852',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '235640',
          hex: '#AFC3B9',
          ccid: '3000890',
          href: '/vi/mau-sac-bang-mau/forest-flush-15gg-53-086-3000890',
          name: 'Forest Flush 15GG 53/086',
          title: 'Forest Flush 15GG 53/086',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000890',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '49329',
          hex: '#A1CCCA',
          ccid: '3001101',
          href: '/vi/mau-sac-bang-mau/aqua-chintz-90gg-57-146-3001101',
          name: 'Aqua Chintz 90GG 57/146',
          title: 'Aqua Chintz 90GG 57/146',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001101',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '49334',
          hex: '#ACD6D8',
          ccid: '3000853',
          href: '/vi/mau-sac-bang-mau/lake-blue-10bg-63-143-3000853',
          name: 'Lake Blue 10BG 63/143',
          title: 'Lake Blue 10BG 63/143',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000853',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '235474',
          hex: '#CDD8CD',
          ccid: '3001075',
          href: '/vi/mau-sac-bang-mau/musk-scene-77gy-68-066-3001075',
          name: 'Musk Scene 77GY 68/066',
          title: 'Musk Scene 77GY 68/066',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001075',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '49327',
          hex: '#C3E3DF',
          ccid: '3001102',
          href: '/vi/mau-sac-bang-mau/aqua-tint-90gg-74-108-3001102',
          name: 'Aqua Tint 90GG 74/108',
          title: 'Aqua Tint 90GG 74/108',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001102',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '52869',
          hex: '#C6E1E1',
          ccid: '3000854',
          href: '/vi/mau-sac-bang-mau/summer-showers-10bg-72-092-3000854',
          name: 'Summer Showers 10BG 72/092',
          title: 'Summer Showers 10BG 72/092',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000854',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '100931',
          hex: '#E5EAE5',
          ccid: '3000930',
          href: '/vi/mau-sac-bang-mau/soft-green-30gg-83-025-3000930',
          name: 'Soft Green 30GG 83/025',
          title: 'Soft Green 30GG 83/025',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000930',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '52856',
          hex: '#DDEDEA',
          ccid: '3001104',
          href: '/vi/mau-sac-bang-mau/gentle-clarity-90gg-83-057-3001104',
          name: 'Gentle Clarity 90GG 83/057',
          title: 'Gentle Clarity 90GG 83/057',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001104',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '52868',
          hex: '#DCEDEC',
          ccid: '3000855',
          href: '/vi/mau-sac-bang-mau/diamond-blue-10bg-83-061-3000855',
          name: 'Diamond Blue 10BG 83/061',
          title: 'Diamond Blue 10BG 83/061',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000855',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '49577',
          hex: '#E5E9E4',
          ccid: '3000992',
          href: '/vi/mau-sac-bang-mau/icy-pond-50gg-83-023-3000992',
          name: 'Icy Pond 50GG 83/023',
          title: 'Icy Pond 50GG 83/023',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000992',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '49573',
          hex: '#E2ECE6',
          ccid: '3000993',
          href: '/vi/mau-sac-bang-mau/breakers-50gg-83-034-3000993',
          name: 'Breakers 50GG 83/034',
          title: 'Breakers 50GG 83/034',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000993',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '235726',
          hex: '#DEEBE5',
          ccid: '3000909',
          href: '/vi/mau-sac-bang-mau/water-sensation-28gg-82-048-3000909',
          name: 'Water Sensation 28GG 82/048',
          title: 'Water Sensation 28GG 82/048',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000909',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '235836',
          hex: '#E7EAE4',
          ccid: '2753462',
          href: '/vi/mau-sac-bang-mau/pale-diamond-45gy-83-023-2753462',
          name: 'Pale Diamond 45GY 83/023',
          title: 'Pale Diamond 45GY 83/023',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753462',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '266007',
          hex: '#E6E9E6',
          ccid: '3001103',
          href: '/vi/mau-sac-bang-mau/snowed-in-90gg-83-011-3001103',
          name: 'Snowed In 90GG 83/011',
          title: 'Snowed In 90GG 83/011',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001103',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '49582',
          hex: '#DBE1E1',
          ccid: '3000985',
          href: '/vi/mau-sac-bang-mau/silver-streak-50bg-76-023-3000985',
          name: 'Silver Streak 50BG 76/023',
          title: 'Silver Streak 50BG 76/023',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000985',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '53209',
          hex: '#D5DDD8',
          ccid: '3000990',
          href: '/vi/mau-sac-bang-mau/light-opal-50gg-73-031-3000990',
          name: 'Light Opal 50GG 73/031',
          title: 'Light Opal 50GG 73/031',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000990',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '49585',
          hex: '#D6DAD7',
          ccid: '3000926',
          href: '/vi/mau-sac-bang-mau/swiss-white-30bg-72-017-3000926',
          name: 'Swiss White 30BG 72/017',
          title: 'Swiss White 30BG 72/017',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000926',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '265773',
          hex: '#DBE0E0',
          ccid: '3001065',
          href: '/vi/mau-sac-bang-mau/marianna-s-aria-72bg-75-023-3001065',
          name: "Marianna's Aria 72BG 75/023",
          title: "Marianna's Aria 72BG 75/023",
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001065',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '53210',
          hex: '#C6D1CD',
          ccid: '3000989',
          href: '/vi/mau-sac-bang-mau/grey-leaf-50gg-63-042-3000989',
          name: 'Grey Leaf 50GG 63/042',
          title: 'Grey Leaf 50GG 63/042',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000989',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '49844',
          hex: '#C9CBC9',
          ccid: '3000929',
          href: '/vi/mau-sac-bang-mau/silver-quill-30gg-61-010-3000929',
          name: 'Silver Quill 30GG 61/010',
          title: 'Silver Quill 30GG 61/010',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000929',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '264911',
          hex: '#C9D1D2',
          ccid: '3000984',
          href: '/vi/mau-sac-bang-mau/paddlewheel-grey-50bg-64-028-3000984',
          name: 'Paddlewheel Grey 50BG 64/028',
          title: 'Paddlewheel Grey 50BG 64/028',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000984',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '235860',
          hex: '#A9B7B3',
          ccid: '3001015',
          href: '/vi/mau-sac-bang-mau/island-evening-54gg-47-053-3001015',
          name: 'Island Evening 54GG 47/053',
          title: 'Island Evening 54GG 47/053',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001015',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '49845',
          hex: '#B8BBB9',
          ccid: '3000928',
          href: '/vi/mau-sac-bang-mau/frost-grey-30gg-52-011-3000928',
          name: 'Frost Grey 30GG 52/011',
          title: 'Frost Grey 30GG 52/011',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000928',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '49407',
          hex: '#B7C3C5',
          ccid: '3000925',
          href: '/vi/mau-sac-bang-mau/limoges-blue-30bg-56-045-3000925',
          name: 'Limoges Blue 30BG 56/045',
          title: 'Limoges Blue 30BG 56/045',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000925',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '53211',
          hex: '#98A9A4',
          ccid: '3000988',
          href: '/vi/mau-sac-bang-mau/gravel-pit-50gg-40-064-3000988',
          name: 'Gravel Pit 50GG 40/064',
          title: 'Gravel Pit 50GG 40/064',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000988',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '49862',
          hex: '#A2A5A5',
          ccid: '3000981',
          href: '/vi/mau-sac-bang-mau/west-coast-grey-50bg-38-011-3000981',
          name: 'West Coast Grey 50BG 38/011',
          title: 'West Coast Grey 50BG 38/011',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000981',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '259334',
          hex: '#9DAAAE',
          ccid: '3001045',
          href: '/vi/mau-sac-bang-mau/spa-blue-70bg-40-050-3001045',
          name: 'Spa Blue 70BG 40/050',
          title: 'Spa Blue 70BG 40/050',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001045',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '100941',
          hex: '#6D837D',
          ccid: '3000987',
          href: '/vi/mau-sac-bang-mau/midnight-garden-50gg-23-085-3000987',
          name: 'Midnight Garden 50GG 23/085',
          title: 'Midnight Garden 50GG 23/085',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000987',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '2849',
          hex: '#8F9391',
          ccid: '3001030',
          href: '/vi/mau-sac-bang-mau/slick-seal-62gg-31-016-3001030',
          name: 'Slick Seal 62GG 31/016',
          title: 'Slick Seal 62GG 31/016',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001030',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '259331',
          hex: '#829096',
          ccid: '3001044',
          href: '/vi/mau-sac-bang-mau/gentry-blue-70bg-28-060-3001044',
          name: 'Gentry Blue 70BG 28/060',
          title: 'Gentry Blue 70BG 28/060',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001044',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '235981',
          hex: '#627775',
          ccid: '3001078',
          href: '/vi/mau-sac-bang-mau/cheeky-grey-78gg-19-078-3001078',
          name: 'Cheeky Grey 78GG 19/078',
          title: 'Cheeky Grey 78GG 19/078',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001078',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '236687',
          hex: '#676A6B',
          ccid: '2753289',
          href: '/vi/mau-sac-bang-mau/grey-cable-03bb-17-015-2753289',
          name: 'Grey Cable 03BB 17/015',
          title: 'Grey Cable 03BB 17/015',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753289',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '2828',
          hex: '#555C5E',
          ccid: '3001077',
          href: '/vi/mau-sac-bang-mau/magnetic-field-78bg-12-032-3001077',
          name: 'Magnetic Field 78BG 12/032',
          title: 'Magnetic Field 78BG 12/032',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001077',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '74286',
          hex: '#2D3D39',
          ccid: '3000986',
          href: '/vi/mau-sac-bang-mau/tavern-green-50gg-05-063-3000986',
          name: 'Tavern Green 50GG 05/063',
          title: 'Tavern Green 50GG 05/063',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000986',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '236878',
          hex: '#505354',
          ccid: '2753624',
          href: '/vi/mau-sac-bang-mau/intense-gunmetal-90bg-11-016-2753624',
          name: 'Intense Gunmetal 90BG 11/016',
          title: 'Intense Gunmetal 90BG 11/016',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753624',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '236876',
          hex: '#3C3E3E',
          ccid: '2753315',
          href: '/vi/mau-sac-bang-mau/skylight-darkness-09bb-07-008-2753315',
          name: 'Skylight Darkness 09BB 07/008',
          title: 'Skylight Darkness 09BB 07/008',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753315',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
    ],
    hueName: 'Teal',
  },
  {
    main: '#4376A3',
    image: {
      src: '/content/dam/akzonobel-common/colorWall/RCC_4/Blue.jpg',
    },
    colors: [
      {
        color: {
          id: '49396',
          hex: '#136777',
          ccid: '3000978',
          href: '/vi/mau-sac-bang-mau/middy-blue-50bg-12-219-3000978',
          name: 'Middy Blue 50BG 12/219',
          title: 'Middy Blue 50BG 12/219',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000978',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '52335',
          hex: '#25485C',
          ccid: '3000844',
          href: '/vi/mau-sac-bang-mau/arctic-night-10bb-07-150-3000844',
          name: 'Arctic Night 10BB 07/150',
          title: 'Arctic Night 10BB 07/150',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000844',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '52334',
          hex: '#274C68',
          ccid: '3000912',
          href: '/vi/mau-sac-bang-mau/mediterranean-blue-30bb-08-188-3000912',
          name: 'Mediterranean Blue 30BB 08/188',
          title: 'Mediterranean Blue 30BB 08/188',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000912',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '49395',
          hex: '#338193',
          ccid: '3000979',
          href: '/vi/mau-sac-bang-mau/west-pointe-blue-50bg-20-230-3000979',
          name: 'West Pointe Blue 50BG 20/230',
          title: 'West Pointe Blue 50BG 20/230',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000979',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '52327',
          hex: '#005476',
          ccid: '3000845',
          href: '/vi/mau-sac-bang-mau/blue-bolt-10bb-09-250-3000845',
          name: 'Blue Bolt 10BB 09/250',
          title: 'Blue Bolt 10BB 09/250',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000845',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '236959',
          hex: '#1D567C',
          ccid: '3000914',
          href: '/vi/mau-sac-bang-mau/deckchair-stripe-30bb-11-244-3000914',
          name: 'Deckchair Stripe 30BB 11/244',
          title: 'Deckchair Stripe 30BB 11/244',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000914',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '49394',
          hex: '#519BAD',
          ccid: '3000980',
          href: '/vi/mau-sac-bang-mau/the-blues-50bg-30-235-3000980',
          name: 'The Blues 50BG 30/235',
          title: 'The Blues 50BG 30/235',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000980',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '236863',
          hex: '#457697',
          ccid: '2753342',
          href: '/vi/mau-sac-bang-mau/icelandic-waters-15bb-19-227-2753342',
          name: 'Icelandic Waters 15BB 19/227',
          title: 'Icelandic Waters 15BB 19/227',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753342',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '236978',
          hex: '#446A8B',
          ccid: '3000955',
          href: '/vi/mau-sac-bang-mau/condor-blues-31bb-15-212-3000955',
          name: 'Condor Blues 31BB 15/212',
          title: 'Condor Blues 31BB 15/212',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000955',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '49393',
          hex: '#83B8C5',
          ccid: '3000982',
          href: '/vi/mau-sac-bang-mau/michigan-lakes-50bg-44-184-3000982',
          name: 'Michigan Lakes 50BG 44/184',
          title: 'Michigan Lakes 50BG 44/184',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000982',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '236785',
          hex: '#67A0C1',
          ccid: '3000836',
          href: '/vi/mau-sac-bang-mau/blue-moment-04bb-34-244-3000836',
          name: 'Blue Moment 04BB 34/244',
          title: 'Blue Moment 04BB 34/244',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000836',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '52954',
          hex: '#6790B3',
          ccid: '3000916',
          href: '/vi/mau-sac-bang-mau/dream-spiral-30bb-27-236-3000916',
          name: 'Dream Spiral 30BB 27/236',
          title: 'Dream Spiral 30BB 27/236',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000916',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '49391',
          hex: '#B0D3DB',
          ccid: '3000983',
          href: '/vi/mau-sac-bang-mau/glistening-sea-50bg-62-133-3000983',
          name: 'Glistening Sea 50BG 62/133',
          title: 'Glistening Sea 50BG 62/133',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000983',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '236762',
          hex: '#7FB7D6',
          ccid: '3001126',
          href: '/vi/mau-sac-bang-mau/water-rush-98bg-45-237-3001126',
          name: 'Water Rush 98BG 45/237',
          title: 'Water Rush 98BG 45/237',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001126',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '48913',
          hex: '#9BB6D1',
          ccid: '3000919',
          href: '/vi/mau-sac-bang-mau/virtuoso-30bb-47-179-3000919',
          name: 'Virtuoso 30BB 47/179',
          title: 'Virtuoso 30BB 47/179',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000919',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '236359',
          hex: '#C5E4E9',
          ccid: '2753425',
          href: '/vi/mau-sac-bang-mau/denim-fantasy-34bg-75-107-2753425',
          name: 'Denim Fantasy 34BG 75/107',
          title: 'Denim Fantasy 34BG 75/107',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753425',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '48451',
          hex: '#B1D2E6',
          ccid: '3001127',
          href: '/vi/mau-sac-bang-mau/celestial-99bg-62-159-3001127',
          name: 'Celestial 99BG 62/159',
          title: 'Celestial 99BG 62/159',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001127',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '48918',
          hex: '#C2D0DF',
          ccid: '3000921',
          href: '/vi/mau-sac-bang-mau/blue-silk-30bb-63-097-3000921',
          name: 'Blue Silk 30BB 63/097',
          title: 'Blue Silk 30BB 63/097',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000921',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '236304',
          hex: '#D6E8E8',
          ccid: '3000883',
          href: '/vi/mau-sac-bang-mau/exciting-summer-12bg-79-065-3000883',
          name: 'Exciting Summer 12BG 79/065',
          title: 'Exciting Summer 12BG 79/065',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000883',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '48886',
          hex: '#C9DEE9',
          ccid: '3001100',
          href: '/vi/mau-sac-bang-mau/skier-s-trail-90bg-72-100-3001100',
          name: "Skier's Trail 90BG 72/100",
          title: "Skier's Trail 90BG 72/100",
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001100',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '48910',
          hex: '#D8E0E9',
          ccid: '3000910',
          href: '/vi/mau-sac-bang-mau/tailwind-29bb-75-065-3000910',
          name: 'Tailwind 29BB 75/065',
          title: 'Tailwind 29BB 75/065',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000910',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '265236',
          hex: '#E2E7E7',
          ccid: '3001017',
          href: '/vi/mau-sac-bang-mau/chilly-morning-56bg-81-023-3001017',
          name: 'Chilly Morning 56BG 81/023',
          title: 'Chilly Morning 56BG 81/023',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001017',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '236888',
          hex: '#E1E7EA',
          ccid: '3000835',
          href: '/vi/mau-sac-bang-mau/ski-adventure-02bb-81-030-3000835',
          name: 'Ski Adventure 02BB 81/030',
          title: 'Ski Adventure 02BB 81/030',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000835',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '52941',
          hex: '#D7DDE1',
          ccid: '3000848',
          href: '/vi/mau-sac-bang-mau/horizons-10bb-73-039-3000848',
          name: 'Horizons 10BB 73/039',
          title: 'Horizons 10BB 73/039',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000848',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '52944',
          hex: '#E8EAE9',
          ccid: '3000850',
          href: '/vi/mau-sac-bang-mau/drifting-snow-10bb-83-014-3000850',
          name: 'Drifting Snow 10BB 83/014',
          title: 'Drifting Snow 10BB 83/014',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000850',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '263897',
          hex: '#E8EAE9',
          ccid: '3000849',
          href: '/vi/mau-sac-bang-mau/atmosphere-10bb-83-006-3000849',
          name: 'Atmosphere 10BB 83/006',
          title: 'Atmosphere 10BB 83/006',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000849',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '237071',
          hex: '#E0E4E8',
          ccid: '2753360',
          href: '/vi/mau-sac-bang-mau/frosty-mist-17bb-79-028-2753360',
          name: 'Frosty Mist 17BB 79/028',
          title: 'Frosty Mist 17BB 79/028',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753360',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '236688',
          hex: '#D9DEDF',
          ccid: '2753485',
          href: '/vi/mau-sac-bang-mau/whale-sensation-50bg-74-020-2753485',
          name: 'Whale Sensation 50BG 74/020',
          title: 'Whale Sensation 50BG 74/020',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753485',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '264346',
          hex: '#DADAD9',
          ccid: '3000922',
          href: '/vi/mau-sac-bang-mau/touch-of-grey-30bb-72-003-3000922',
          name: 'Touch of Grey 30BB 72/003',
          title: 'Touch of Grey 30BB 72/003',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000922',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '236963',
          hex: '#DAE0E2',
          ccid: '3000837',
          href: '/vi/mau-sac-bang-mau/groovy-grey-04bb-75-027-3000837',
          name: 'Groovy Grey 04BB 75/027',
          title: 'Groovy Grey 04BB 75/027',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000837',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '49438',
          hex: '#C7D0D4',
          ccid: '3001099',
          href: '/vi/mau-sac-bang-mau/fostoria-glass-90bg-63-043-3001099',
          name: 'Fostoria Glass 90BG 63/043',
          title: 'Fostoria Glass 90BG 63/043',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001099',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '236885',
          hex: '#CDD3D5',
          ccid: '2753603',
          href: '/vi/mau-sac-bang-mau/cheeky-sprite-84bg-66-028-2753603',
          name: 'Cheeky Sprite 84BG 66/028',
          title: 'Cheeky Sprite 84BG 66/028',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753603',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '49868',
          hex: '#BDBFC0',
          ccid: '3000920',
          href: '/vi/mau-sac-bang-mau/silver-trophy-30bb-53-012-3000920',
          name: 'Silver Trophy 30BB 53/012',
          title: 'Silver Trophy 30BB 53/012',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000920',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '236698',
          hex: '#A7B1B6',
          ccid: '2753625',
          href: '/vi/mau-sac-bang-mau/breaking-grey-90bg-44-049-2753625',
          name: 'Breaking Grey 90BG 44/049',
          title: 'Breaking Grey 90BG 44/049',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753625',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '100833',
          hex: '#B8C4CC',
          ccid: '3000847',
          href: '/vi/mau-sac-bang-mau/faded-denim-10bb-55-065-3000847',
          name: 'Faded Denim 10BB 55/065',
          title: 'Faded Denim 10BB 55/065',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000847',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '49869',
          hex: '#AFB1B3',
          ccid: '3000918',
          href: '/vi/mau-sac-bang-mau/surreal-blue-30bb-45-015-3000918',
          name: 'Surreal Blue 30BB 45/015',
          title: 'Surreal Blue 30BB 45/015',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000918',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '53249',
          hex: '#8F9EA5',
          ccid: '3001098',
          href: '/vi/mau-sac-bang-mau/shadow-play-90bg-35-068-3001098',
          name: 'Shadow Play 90BG 35/068',
          title: 'Shadow Play 90BG 35/068',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001098',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '236824',
          hex: '#95A7B4',
          ccid: '3000846',
          href: '/vi/mau-sac-bang-mau/mouse-morning-10bb-39-100-3000846',
          name: 'Mouse Morning 10BB 39/100',
          title: 'Mouse Morning 10BB 39/100',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000846',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '264324',
          hex: '#90969C',
          ccid: '3000917',
          href: '/vi/mau-sac-bang-mau/chiseled-grey-30bb-31-043-3000917',
          name: 'Chiseled Grey 30BB 31/043',
          title: 'Chiseled Grey 30BB 31/043',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000917',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '236701',
          hex: '#7C8D95',
          ccid: '2753611',
          href: '/vi/mau-sac-bang-mau/brooding-storm-87bg-27-077-2753611',
          name: 'Brooding Storm 87BG 27/077',
          title: 'Brooding Storm 87BG 27/077',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753611',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '236894',
          hex: '#7E8D99',
          ccid: '3000891',
          href: '/vi/mau-sac-bang-mau/energetic-watertide-16bb-27-091-3000891',
          name: 'Energetic Watertide 16BB 27/091',
          title: 'Energetic Watertide 16BB 27/091',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000891',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '74100',
          hex: '#737B84',
          ccid: '3000915',
          href: '/vi/mau-sac-bang-mau/evening-shadow-30bb-21-056-3000915',
          name: 'Evening Shadow 30BB 21/056',
          title: 'Evening Shadow 30BB 21/056',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000915',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '49443',
          hex: '#5E717B',
          ccid: '3001097',
          href: '/vi/mau-sac-bang-mau/connecticut-blue-90bg-17-090-3001097',
          name: 'Connecticut Blue 90BG 17/090',
          title: 'Connecticut Blue 90BG 17/090',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001097',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '236896',
          hex: '#4E5B66',
          ccid: '3000903',
          href: '/vi/mau-sac-bang-mau/whale-wall-21bb-12-077-3000903',
          name: 'Whale Wall 21BB 12/077',
          title: 'Whale Wall 21BB 12/077',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000903',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '259233',
          hex: '#4D4F52',
          ccid: '3000913',
          href: '/vi/mau-sac-bang-mau/noble-grey-30bb-10-019-3000913',
          name: 'Noble Grey 30BB 10/019',
          title: 'Noble Grey 30BB 10/019',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000913',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '236703',
          hex: '#364A55',
          ccid: '2753619',
          href: '/vi/mau-sac-bang-mau/ink-explosion-89bg-09-087-2753619',
          name: 'Ink Explosion 89BG 09/087',
          title: 'Ink Explosion 89BG 09/087',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753619',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '236892',
          hex: '#3D454D',
          ccid: '3000897',
          href: '/vi/mau-sac-bang-mau/newspaper-ink-20bb-08-051-3000897',
          name: 'Newspaper Ink 20BB 08/051',
          title: 'Newspaper Ink 20BB 08/051',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000897',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '100899',
          hex: '#343639',
          ccid: '3000911',
          href: '/vi/mau-sac-bang-mau/black-mica-30bb-05-022-3000911',
          name: 'Black Mica 30BB 05/022',
          title: 'Black Mica 30BB 05/022',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000911',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
    ],
    hueName: 'Blue',
  },
  {
    main: '#745184',
    image: {
      src: '/content/dam/akzonobel-common/colorWall/RCC_4/Violet.jpg',
    },
    colors: [
      {
        color: {
          id: '48465',
          hex: '#333D6B',
          ccid: '3001120',
          href: '/vi/mau-sac-bang-mau/twilight-zone-91bb-07-263-3001120',
          name: 'Twilight Zone 91BB 07/263',
          title: 'Twilight Zone 91BB 07/263',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001120',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '52328',
          hex: '#55455E',
          ccid: '3000996',
          href: '/vi/mau-sac-bang-mau/purple-haze-50rb-09-156-3000996',
          name: 'Purple Haze 50RB 09/156',
          title: 'Purple Haze 50RB 09/156',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000996',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '237362',
          hex: '#3C3A48',
          ccid: '2753304',
          href: '/vi/mau-sac-bang-mau/blackforest-gateau-07rb-07-079-2753304',
          name: 'Blackforest Gateau 07RB 07/079',
          title: 'Blackforest Gateau 07RB 07/079',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753304',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '237219',
          hex: '#546894',
          ccid: '3001066',
          href: '/vi/mau-sac-bang-mau/powerfull-plum-73bb-16-259-3001066',
          name: 'Powerfull Plum 73BB 16/259',
          title: 'Powerfull Plum 73BB 16/259',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001066',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '53043',
          hex: '#624B6E',
          ccid: '3000997',
          href: '/vi/mau-sac-bang-mau/california-raisin-50rb-10-219-3000997',
          name: 'California Raisin 50RB 10/219',
          title: 'California Raisin 50RB 10/219',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000997',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '237424',
          hex: '#585568',
          ccid: '2753317',
          href: '/vi/mau-sac-bang-mau/midnight-glow-09rb-12-102-2753317',
          name: 'Midnight Glow 09RB 12/102',
          title: 'Midnight Glow 09RB 12/102',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753317',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '48938',
          hex: '#8998BC',
          ccid: '3001040',
          href: '/vi/mau-sac-bang-mau/basin-street-blue-70bb-33-202-3001040',
          name: 'Basin Street Blue 70BB 33/202',
          title: 'Basin Street Blue 70BB 33/202',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001040',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '53038',
          hex: '#867091',
          ccid: '3000998',
          href: '/vi/mau-sac-bang-mau/grape-surprise-50rb-20-199-3000998',
          name: 'Grape Surprise 50RB 20/199',
          title: 'Grape Surprise 50RB 20/199',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000998',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '74182',
          hex: '#6F6C81',
          ccid: '3000864',
          href: '/vi/mau-sac-bang-mau/pinot-noir-10rb-17-122-3000864',
          name: 'Pinot Noir 10RB 17/122',
          title: 'Pinot Noir 10RB 17/122',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000864',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '52984',
          hex: '#A6AFC8',
          ccid: '3001041',
          href: '/vi/mau-sac-bang-mau/fairy-dust-70bb-44-144-3001041',
          name: 'Fairy Dust 70BB 44/144',
          title: 'Fairy Dust 70BB 44/144',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001041',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '100880',
          hex: '#A493AC',
          ccid: '3000999',
          href: '/vi/mau-sac-bang-mau/vineyard-passage-50rb-34-153-3000999',
          name: 'Vineyard Passage 50RB 34/153',
          title: 'Vineyard Passage 50RB 34/153',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000999',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '53288',
          hex: '#9A95A6',
          ccid: '3000939',
          href: '/vi/mau-sac-bang-mau/magical-twilight-30rb-33-103-3000939',
          name: 'Magical Twilight 30RB 33/103',
          title: 'Magical Twilight 30RB 33/103',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000939',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '237170',
          hex: '#C2C7D6',
          ccid: '3001068',
          href: '/vi/mau-sac-bang-mau/winters-poet-74bb-58-090-3001068',
          name: 'Winters Poet 74BB 58/090',
          title: 'Winters Poet 74BB 58/090',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001068',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '100879',
          hex: '#C6B9CA',
          ccid: '3001000',
          href: '/vi/mau-sac-bang-mau/sensual-senses-50rb-52-107-3001000',
          name: 'Sensual Senses 50RB 52/107',
          title: 'Sensual Senses 50RB 52/107',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001000',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '53287',
          hex: '#BEB9C5',
          ccid: '3000942',
          href: '/vi/mau-sac-bang-mau/silver-night-30rb-50-072-3000942',
          name: 'Silver Night 30RB 50/072',
          title: 'Silver Night 30RB 50/072',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000942',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '237077',
          hex: '#CFD7E3',
          ccid: '2753498',
          href: '/vi/mau-sac-bang-mau/lavender-morning-53bb-69-079-2753498',
          name: 'Lavender Morning 53BB 69/079',
          title: 'Lavender Morning 53BB 69/079',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753498',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '53033',
          hex: '#D8D0D9',
          ccid: '3001001',
          href: '/vi/mau-sac-bang-mau/evening-aperitif-50rb-66-066-3001001',
          name: 'Evening Aperitif 50RB 66/066',
          title: 'Evening Aperitif 50RB 66/066',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001001',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '49469',
          hex: '#D1D1D6',
          ccid: '3000865',
          href: '/vi/mau-sac-bang-mau/vogue-violet-10rb-65-042-3000865',
          name: 'Vogue Violet 10RB 65/042',
          title: 'Vogue Violet 10RB 65/042',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000865',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '237247',
          hex: '#DFE2E7',
          ccid: '2753541',
          href: '/vi/mau-sac-bang-mau/lavender-touch-66bb-77-035-2753541',
          name: 'Lavender Touch 66BB 77/035',
          title: 'Lavender Touch 66BB 77/035',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753541',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '53032',
          hex: '#E0DDE0',
          ccid: '3001002',
          href: '/vi/mau-sac-bang-mau/castle-in-the-air-50rb-74-033-3001002',
          name: 'Castle in the Air 50RB 74/033',
          title: 'Castle in the Air 50RB 74/033',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001002',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '49468',
          hex: '#DFDDE2',
          ccid: '3000866',
          href: '/vi/mau-sac-bang-mau/mystic-purple-10rb-74-038-3000866',
          name: 'Mystic Purple 10RB 74/038',
          title: 'Mystic Purple 10RB 74/038',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000866',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '237240',
          hex: '#E7E9EB',
          ccid: '3000964',
          href: '/vi/mau-sac-bang-mau/sea-crystals-40bb-83-017-3000964',
          name: 'Sea Crystals 40BB 83/017',
          title: 'Sea Crystals 40BB 83/017',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000964',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '266119',
          hex: '#EDEAEB',
          ccid: '3001112',
          href: '/vi/mau-sac-bang-mau/summer-wedding-90rb-83-015-3001112',
          name: 'Summer Wedding 90RB 83/015',
          title: 'Summer Wedding 90RB 83/015',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001112',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '52995',
          hex: '#ECEAED',
          ccid: '3001096',
          href: '/vi/mau-sac-bang-mau/fresh-air-90bb-83-020-3001096',
          name: 'Fresh Air 90BB 83/020',
          title: 'Fresh Air 90BB 83/020',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001096',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '52951',
          hex: '#E8EAEB',
          ccid: '3000924',
          href: '/vi/mau-sac-bang-mau/pearl-drop-30bb-83-018-3000924',
          name: 'Pearl Drop 30BB 83/018',
          title: 'Pearl Drop 30BB 83/018',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000924',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '53057',
          hex: '#DFDBDA',
          ccid: '3000868',
          href: '/vi/mau-sac-bang-mau/wings-of-a-dove-10rr-73-016-3000868',
          name: 'Wings of a Dove 10RR 73/016',
          title: 'Wings of a Dove 10RR 73/016',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000868',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '100894',
          hex: '#E8E8E4',
          ccid: '3000923',
          href: '/vi/mau-sac-bang-mau/silk-moon-30bb-83-001-3000923',
          name: 'Silk Moon 30BB 83/001',
          title: 'Silk Moon 30BB 83/001',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000923',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '49460',
          hex: '#DADBDC',
          ccid: '3001043',
          href: '/vi/mau-sac-bang-mau/white-wisteria-70bb-73-020-3001043',
          name: 'White Wisteria 70BB 73/020',
          title: 'White Wisteria 70BB 73/020',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001043',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '237987',
          hex: '#E3DBDC',
          ccid: '2753401',
          href: '/vi/mau-sac-bang-mau/morning-dewdrops-26rr-73-037-2753401',
          name: 'Morning Dewdrops 26RR 73/037',
          title: 'Morning Dewdrops 26RR 73/037',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753401',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '236057',
          hex: '#D9DAD8',
          ccid: '2753309',
          href: '/vi/mau-sac-bang-mau/grey-clouds-08gg-72-006-2753309',
          name: 'Grey Clouds 08GG 72/006',
          title: 'Grey Clouds 08GG 72/006',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753309',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '49461',
          hex: '#CCCED3',
          ccid: '3001042',
          href: '/vi/mau-sac-bang-mau/smoky-white-70bb-64-035-3001042',
          name: 'Smoky White 70BB 64/035',
          title: 'Smoky White 70BB 64/035',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001042',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '232268',
          hex: '#DBCFD0',
          ccid: '3001038',
          href: '/vi/mau-sac-bang-mau/burning-sky-67rr-66-044-3001038',
          name: 'Burning Sky 67RR 66/044',
          title: 'Burning Sky 67RR 66/044',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001038',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '236055',
          hex: '#CBCCCB',
          ccid: '2753615',
          href: '/vi/mau-sac-bang-mau/light-charcoal-88bg-62-005-2753615',
          name: 'Light Charcoal 88BG 62/005',
          title: 'Light Charcoal 88BG 62/005',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753615',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '49479',
          hex: '#B8B5BC',
          ccid: '3000941',
          href: '/vi/mau-sac-bang-mau/little-lilac-30rb-49-042-3000941',
          name: 'Little Lilac 30RB 49/042',
          title: 'Little Lilac 30RB 49/042',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000941',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '53073',
          hex: '#C3B3B8',
          ccid: '3000943',
          href: '/vi/mau-sac-bang-mau/soft-wine-30rr-49-067-3000943',
          name: 'Soft Wine 30RR 49/067',
          title: 'Soft Wine 30RR 49/067',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000943',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '237406',
          hex: '#BCBDBB',
          ccid: '3000977',
          href: '/vi/mau-sac-bang-mau/silky-stone-49gg-52-001-3000977',
          name: 'Silky Stone 49GG 52/001',
          title: 'Silky Stone 49GG 52/001',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000977',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '49480',
          hex: '#A09DA7',
          ccid: '3000940',
          href: '/vi/mau-sac-bang-mau/velvet-glove-30rb-36-055-3000940',
          name: 'Velvet Glove 30RB 36/055',
          title: 'Velvet Glove 30RB 36/055',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000940',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '237787',
          hex: '#9A8B92',
          ccid: '2753326',
          href: '/vi/mau-sac-bang-mau/clay-touch-11rr-29-068-2753326',
          name: 'Clay Touch 11RR 29/068',
          title: 'Clay Touch 11RR 29/068',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753326',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '236051',
          hex: '#9E9F9E',
          ccid: '2753497',
          href: '/vi/mau-sac-bang-mau/grey-couture-53bb-36-004-2753497',
          name: 'Grey Couture 53BB 36/004',
          title: 'Grey Couture 53BB 36/004',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753497',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '49481',
          hex: '#8A8692',
          ccid: '3000938',
          href: '/vi/mau-sac-bang-mau/rendezvous-30rb-26-067-3000938',
          name: 'Rendezvous 30RB 26/067',
          title: 'Rendezvous 30RB 26/067',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000938',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '237803',
          hex: '#84747C',
          ccid: '2753318',
          href: '/vi/mau-sac-bang-mau/purple-clay-09rr-21-078-2753318',
          name: 'Purple Clay 09RR 21/078',
          title: 'Purple Clay 09RR 21/078',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753318',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '236049',
          hex: '#858585',
          ccid: '2753350',
          href: '/vi/mau-sac-bang-mau/dark-storm-16bb-25-001-2753350',
          name: 'Dark Storm 16BB 25/001',
          title: 'Dark Storm 16BB 25/001',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753350',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '237515',
          hex: '#675F6D',
          ccid: '2753439',
          href: '/vi/mau-sac-bang-mau/pacific-purple-38rb-15-086-2753439',
          name: 'Pacific Purple 38RB 15/086',
          title: 'Pacific Purple 38RB 15/086',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753439',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '237788',
          hex: '#705F68',
          ccid: '2753291',
          href: '/vi/mau-sac-bang-mau/aubergine-swing-04rr-14-085-2753291',
          name: 'Aubergine Swing 04RR 14/085',
          title: 'Aubergine Swing 04RR 14/085',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753291',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '236046',
          hex: '#616160',
          ccid: '2753434',
          href: '/vi/mau-sac-bang-mau/plush-pewter-36rr-14-002-2753434',
          name: 'Plush Pewter 36RR 14/002',
          title: 'Plush Pewter 36RR 14/002',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753434',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '49483',
          hex: '#484253',
          ccid: '2753411',
          href: '/vi/mau-sac-bang-mau/black-tulip-30rb-07-107-2753411',
          name: 'Black Tulip 30RB 07/107',
          title: 'Black Tulip 30RB 07/107',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_2753411',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '264124',
          hex: '#54414C',
          ccid: '3000867',
          href: '/vi/mau-sac-bang-mau/renaissance-tapestry-10rr-08-100-3000867',
          name: 'Renaissance Tapestry 10RR 08/100',
          title: 'Renaissance Tapestry 10RR 08/100',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3000867',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
      {
        color: {
          id: '1749',
          hex: '#343333',
          ccid: '3001085',
          href: '/vi/mau-sac-bang-mau/deep-lead-81yr-06-003-3001085',
          name: 'Deep Lead 81YR 06/003',
          title: 'Deep Lead 81YR 06/003',
          hidden: false,
          color2d: {
            colorWall: {
              decoType: 'WALL_RCC_4',
              colorFamilies: [
                {
                  rgb: '#E4043F',
                  order: 1,
                  hueName: 'Red',
                },
                {
                  rgb: '#F28E16',
                  order: 2,
                  hueName: 'Orange',
                },
                {
                  rgb: '#FFEC00',
                  order: 3,
                  hueName: 'Yellow',
                },
                {
                  rgb: '#B7CE0D',
                  order: 4,
                  hueName: 'Lime',
                },
                {
                  rgb: '#3F993F',
                  order: 5,
                  hueName: 'Green',
                },
                {
                  rgb: '#2FAF9F',
                  order: 6,
                  hueName: 'Teal',
                },
                {
                  rgb: '#4376A3',
                  order: 7,
                  hueName: 'Blue',
                },
                {
                  rgb: '#745184',
                  order: 8,
                  hueName: 'Violet',
                },
              ],
            },
            translucent: {
              selectSubstrates: {
                substrates: {},
              },
            },
            optionsorder: {
              translucent: {
                options: [
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/light.png',
                    label: 'light',
                    order: 0,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/middle.png',
                    label: 'middle',
                    order: 1,
                  },
                  {
                    image:
                      'https://msp.images.akzonobel.com/tst/dh/2d/translucent/dark.png',
                    label: 'dark',
                    order: 2,
                  },
                ],
                defaultSubstrate: 'dark',
              },
            },
          },
          display: [],
          globalId: '',
          colorDescription: '',
        },
        links: [
          {
            href: '/content/akzonobel-flourish/dulux/vn/dulux/vi/ung-dung-dulux-visualizer.html',
            image: {},
            title: 'Ứng dụng Dulux Visualizer',
            isAppData: true,
            isEcommerce: false,
            pColorMobileUrl:
              'https://7dtm.adj.st/visualizer/avndlx/visualize?color_uid={0}&adj_t=q97og1r',
          },
        ],
        findProducts: {
          cta: {
            href: '/vi/san-pham/filters/cccId_3001085',
            label: 'Xem Ngay',
            target: '_self',
          },
          mask: {
            alt: 'Visualizer App',
            src: '/content/dam/akzonobel-common/common-assets/bucket-top-view.png',
          },
          title: 'Tìm sản phẩm có màu này',
        },
      },
    ],
    hueName: 'Violet',
  },
];
